(function(){

  /* =========================================================
     PRODUCT DATA
     Real handles/prices/images/variant IDs as a seed snapshot from the
     connected Shopify store's Admin API. At results time, every line item
     (core mounts, poles, accessories, and boat-specific plates alike) gets
     refreshed live via resolveProductLive() using the storefront's public
     product JSON — so price and image changes on existing products show up
     automatically. This snapshot is only what customers see if that live
     refresh can't complete (e.g. previewing off your domain). Boat plates
     additionally stay as a lighter {brand,label,handle,price} record since
     there are 76 of them; only the 1-2 a given customer actually matches
     get resolved.
     ========================================================= */
  const SITE = "https://beatdownoutdoors.com";
  const CDN = "https://cdn.shopify.com/s/files/1/0835/6613/3556/files/";
  // Generic reference photo shown on the leveling-plate picker so customers
  // unfamiliar with the term can see what's being discussed before choosing
  // their specific model. Real product, real photo — not the exact plate
  // every customer gets, so it's captioned to make that clear.
  const LEVELING_PLATE_REFERENCE_IMAGE = CDN + "levelingplaterangerC.jpg?v=1704319785";
  // Example mount photos for the Low/Mid/High height question — one real
  // product per tier so customers can see what each height actually looks
  // like rather than just reading inch ranges.
  const HEIGHT_EXAMPLE_IMAGES = {
    low:  CDN + "singlepoleshortsidetop.png?v=1787064498",
    mid:  CDN + "FlexShorty.png?v=1775139397",
    high: CDN + "ultimatetopside.jpg?v=1702402849"
  };

  const PRODUCTS = {
    // ---- Bow mount tiers ----
    sticUp:        { name:"Stic-Up Mount", handle:"stic-up-mount", price:219.99, variantId:"48260764041524",
                      image:CDN+"sticupbottom.pdf.png?v=1731429914",
                      why:"Lowest-cost bow mount. Built for a single 10\" or smaller graph, 13\"–19\" adjustable." },
    singlePoleShort:{ name:"The Ultimate Single Pole Short (7\")", handle:"copy-of-the-ultimate-single-pole-tall-13", price:369.99, variantId:"47336952004916",
                      image:CDN+"singlepoleshortsidetop.png?v=1787064498",
                      why:"Ultimate-series build quality at a lower, fixed-shorter height — skips the interior telescoping pole." },
    singlePoleTall: { name:"The Ultimate Single Pole Tall (13\")", handle:"the-ultimate-single-pole", price:399.99, variantId:"47860424212788",
                      image:CDN+"singlepolebottomempty.jpg?v=1702919478",
                      why:"Same as the Short, extended to 13\" — Ultimate quality without the full telescoping range." },
    singlePoleShortDouble:{ name:"The Ultimate Single Pole Double Stack (Short, 7\")", handle:"copy-of-the-ultimate-single-pole", price:579.99, variantId:"47336410448180",
                      image:CDN+"singlepoledoubletopside.jpg?v=1702919763",
                      why:"Two graphs on a single pole at a lower, fixed-shorter height — skips the interior telescoping pole." },
    singlePoleTallDouble:{ name:"The Ultimate Single Pole Double Stack (Tall, 13\")", handle:"copy-of-the-ultimate-single-pole", price:599.99, variantId:"47886655717684",
                      image:CDN+"singlepoledoubletopside.jpg?v=1702919763",
                      why:"Two graphs on a single pole, extended to 13\" — Ultimate quality without the full telescoping range." },
    flex:          { name:"The Flex", handle:"the-flex-new", price:349.99, variantId:"47320517804340",
                      image:CDN+"flexsidetop.jpg?v=1702576271",
                      why:"Fold-down mount that pivots up to view, folds flat to run. Single graph up to 12\"." },
    flexHD:        { name:"Flex HD", handle:"flex-hd", price:419.99, variantId:"48342807216436",
                      image:CDN+"FlexHDFinal1.jpg?v=1730989719",
                      why:"Reinforced-base fold-down mount — the standing pick any time you're running 2+ graphs or a graph over 12\"." },
    flexHDDouble:  { name:"Flex HD (Double Stack)", handle:"flex-hd", price:519.99, variantId:"48342807249204",
                      image:CDN+"FlexHDFinal1.jpg?v=1730989719",
                      why:"Reinforced-base fold-down mount, built to stack two graphs." },
    bdHybrid:      { name:"BD Hybrid", handle:"bd-hybrid", price:559.99, variantId:"49239963861300",
                      image:CDN+"Hybrid_8.png?v=1786387793",
                      why:"Combines the Ultimate's strength and durability with the Flex's pivot-and-lay-down design." },
    bdHybridDouble:{ name:"BD Hybrid (Double Stack)", handle:"bd-hybrid", price:789.99, variantId:"49239963894068",
                      image:CDN+"Hybrid_8.png?v=1786387793",
                      why:"Combines the Ultimate's strength and durability with the Flex's pivot-and-lay-down design, built to stack two graphs." },
    ultimate:      { name:"The Ultimate", handle:"the-ultimate", price:559.99, variantId:"47286031057204",
                      image:CDN+"ultimatetopside.jpg?v=1702402849",
                      why:"Flagship mount. Full 0\"–30\" reverse-telescoping range, raise/lower/turn, single graph." },
    ultimateDouble:{ name:"The Ultimate Double Stack", handle:"the-ultimate-double-stack", price:789.99, variantId:"47286041936180",
                      image:CDN+"ultimatedoubletopside.jpg?v=1702403194",
                      why:"The Ultimate, built to stack two large graphs side by side." },
    ultimateQR:    { name:"The Ultimate Quick Release", handle:"the-ultimate-quick-release", price:699.99, variantId:"47286129066292",
                      image:CDN+"ultimateqrsidetop.jpg?v=1702418468",
                      why:"The Ultimate's full range, plus a quick-release base to pull the whole rig off in seconds." },
    ultimateDoubleQR:{ name:"The Ultimate Double Stack Quick Release", handle:"the-ultimate-double-stock-quick-release", price:899.99, variantId:"47286044295476",
                      image:CDN+"ultimateqrdoubletopside.jpg?v=1702417956",
                      why:"Double Stack capacity with the quick-release base." },
    ultimateTriple:{ name:"The Ultimate Triple Quick Release", handle:"the-ultimate-triple-stack-quick-release", price:1049.99, variantId:"47316828979508",
                      image:CDN+"ultimateqrtriplehigh.jpg?v=1702506122",
                      why:"Triple stack is only available in the Ultimate series. Comes as a quick-release model — three graphs, full 0\"–30\" range." },
    flexShorty:    { name:"The Flex Shorty", handle:"the-flex-shorty", price:339.99, variantId:"49075991085364",
                      image:CDN+"FlexShorty.png?v=1775139397",
                      why:"More economical version of The Flex — same fold-down design at a lower profile, single graph up to 12\"." },
    flexDoubleStack:{ name:"The Flex Double Stack", handle:"the-flex-double-stack-new", price:449.99, variantId:"47320540545332",
                      image:CDN+"flexdoubletop.jpg?v=1702576628",
                      why:"The Flex, built to stack two graphs under 12\" each — no lower-profile Shorty version exists for the double-stack." },
    flexHDShorty:  { name:"Flex HD Shorty", handle:"flex-hd-shorty", price:409.99, variantId:"49076015431988",
                      image:CDN+"FlexShortyHD.png?v=1775144080",
                      why:"Lower-profile Flex HD — reinforced base for 2+ graphs or a graph over 12\", at a shorter height." },
    flexHDShortyDouble:{ name:"Flex HD Shorty (Double Stack)", handle:"flex-hd-shorty", price:509.99, variantId:"49076015464756",
                      image:CDN+"FlexShortyHD.png?v=1775144080",
                      why:"Lower-profile Flex HD, built to stack two graphs." },
    ultimateShorty:{ name:"The Ultimate Shorty", handle:"the-ultimate-shorty", price:529.99, variantId:"47315256541492",
                      image:CDN+"shortytopside.jpg?v=1702486309",
                      why:"The Ultimate's full strength and features at a lower-profile 0\"–17\" range, single graph." },
    ultimateShortyQR:{ name:"The Ultimate Shorty Quick Release", handle:"the-ultimate-shorty-quick-release", price:649.99, variantId:"47315691241780",
                      image:CDN+"shortyqrsidetop.jpg?v=1702502433",
                      why:"The Ultimate Shorty with a quick-release base to pull the whole rig off in seconds." },
    ultimateShortyDouble:{ name:"The Ultimate Shorty Double Stack", handle:"the-ultimate-shorty-double-stack", price:749.99, variantId:"47315440402740",
                      image:CDN+"shortydoublesidetop.jpg?v=1702487722",
                      why:"The Ultimate Shorty, built to stack two graphs, 0\"–17\" range." },
    ultimateShortyDoubleQR:{ name:"The Ultimate Shorty Double Stack Quick Release", handle:"the-ultimate-shorty-double-stack-quick-release", price:879.99, variantId:"47316773830964",
                      image:CDN+"shortyqr_0000_doublesidetop.jpg?v=1702504241",
                      why:"The Ultimate Shorty Double Stack with a quick-release base." },
    commander:     { name:"BD Commander Single Pole Mount", handle:"bd-commander-single-pole-mount", price:1249.99, variantId:"49144693817652",
                      image:CDN+"GarminCradle_wGraph.png?v=1773247824",
                      why:"Built specifically for Garmin 9000-series graphs, which don't ship with a factory gimbal." },

    // ---- Console mounts (universal) ----
    ultimateConsoleSingle:{ name:"Ultimate Console Mount (Single)", handle:"ultimate-console-mount", price:539.99, variantId:"47572717076788",
                      image:CDN+"dualconsolein_baa8573f-28c4-4d41-9110-6b1cec9c628f.jpg?v=1706544614",
                      why:"For a flat console — pairs with a console plate to create the mounting surface." },
    ultimateConsoleDual:{ name:"Ultimate Console Mount (Dual)", handle:"ultimate-console-mount", price:649.99, variantId:"47572717109556",
                      image:CDN+"dualconsolein_baa8573f-28c4-4d41-9110-6b1cec9c628f.jpg?v=1706544614",
                      why:"For a flat console with two graphs — pairs with a console plate to create the mounting surface." },
    locDown:       { name:"LocDown Pivot and Slide (Left Hand)", handle:"console-mount", price:299.99, variantId:"47572788871476",
                      image:CDN+"singleconsolewithgraph.jpg?v=1705951593",
                      why:"For a console with a shelf — pivots and slides to work around the raised lip. Also sold in Right Hand and Left+Right Pair — switch at cart if needed." },
    locDownPair:   { name:"LocDown Pivot and Slide (Left and Right Hand Pair)", handle:"console-mount", price:599.98, variantId:"48870383649076",
                      image:CDN+"singleconsolewithgraph.jpg?v=1705951593",
                      why:"Two graphs on a shelf console need one of each hand — this pair variant covers both mounts." },

    // ---- Bow fallback (no boat-specific leveling plate) ----
    bridge:        { name:"Beatdown Bridge", handle:"beatdown-bridge", price:159.99, variantId:"47345493705012",
                      image:CDN+"bridgecenter.jpg?v=1704215765",
                      why:"Spans over the trolling motor pedal so your mount sits up front without blocking foot control. Center-gap variant shown — confirm your gap width at checkout." },
    mountingPlate: { name:"Mounting Plates (Round Base)", handle:"mounting-plate", price:59.99, variantId:"47349673460020",
                      image:CDN+"mountingplateround.jpg?v=1704215987",
                      why:"Mounts to the boat deck with 4 flange bolts — for mounting off to the side of the trolling motor pedal, clear of foot access. Also sold in a Square Base variant." },

    // ---- LiveScope ----
    zeroedIn:      { name:"Zeroed In Live T-Mount", handle:"zero-degree-livescope-mount", price:249.99, variantId:"48910423064884",
                      image:CDN+"0003_11.png?v=1761678651",
                      why:"Zero-degree clamp for Garmin LiveScope 34 — works on a trolling motor shaft or at the tip of a transducer pole." },
    zeroKraken:    { name:"Zero Degree Mount — Kraken Compatible", handle:"zero-degree-garmin-kraken", price:49.99, variantId:"49057960624436",
                      image:CDN+"Kraken_Mount_3.png?v=1772827883",
                      why:"The Kraken's shaft geometry needs its own mount — this is the direct-mount version built for it." },
    transducerFixedStandard:{ name:"Fixed All-Terrain Transducer Pole 2.0", handle:"fixed-transducer-pole-2-0-all-terrain", price:299.99, variantId:"48910422868276",
                      image:CDN+"Fixed2.0-1_b07c4042-ea41-41a8-b2d3-628a3bb30324.png?v=1761677163",
                      why:"Simple, tool-free fixed pole with a pivoting, multi-directional handle. Direct-mount only." },
    transducerBreakawayJr:{ name:"Breakaway Jr. Transducer Pole", handle:"breakaway-jr-transducer-pole-all-terrain", price:399.99, variantId:"48910423490868",
                      image:CDN+"BreakawayJr-3.png?v=1761666678",
                      why:"Compact, breakaway-only pole for kayaks, PWCs, and smaller rigs. Direct-mount only — no track or gunnel option." },
    transducerBreakawayStandard:{ name:"Breakaway All-Terrain Transducer Pole 2.0", handle:"breakaway-transducer-pole-2-0-all-terrain", price:549.99, variantId:"48910423687476",
                      image:CDN+"Breakaway2.0-3.png?v=1761668027",
                      why:"Two poles in one — locks into a fixed position or releases on impact every 90°, with an upgraded pivoting handle." },
    transducerTrackBreakaway:{ name:"BreakAway 2.0 for Track Systems", handle:"breakaway-transducer-pole-track-system", price:549.99, variantId:"48232704803124",
                      image:CDN+"TrackPole1.png?v=1778508574",
                      why:"Fits all major-brand 3\" wide universal accessory tracks. Fixed and breakaway positions in one pole." },
    transducerSportTrack:{ name:"Sport Track Breakaway Pole", handle:"sport-track-breakaway-pole", price:620.00, variantId:"48909120733492",
                      image:CDN+"SportTrack_NewHandle.png?v=1773161519",
                      why:"Breakaway pole built for an integrated gunnel track system." },
    polePointer:   { name:"Pole Pointer", handle:"pole-pointer", price:29.99, variantId:"47534433108276",
                      image:CDN+"bdpointersmall.jpg?v=1706550633",
                      why:"Small aiming reference for dialing in your pole's angle." },

    // ---- Accessories ----
    hardware:      { name:"Mounting Hardware Kit", handle:"mounting-hardware-kit", price:10.00, variantId:"47496016691508",
                      image:CDN+"Hardware-kit__26044.jpg?v=1705959193",
                      why:"Beatdown mounts ship without mounting hardware — 2\" Set of 4 shown, other sizes available on the product page." },
    graphKnobs:    { name:"BD Replacement Graph Knobs", handle:"bd-replacement-graph-knobs", price:34.99, variantId:"47873904410932",
                      image:CDN+"GraphKnobPic2.webp?v=1711659827",
                      variants:[
                        {id:"47873904410932", title:"Garmin/ Lowrance", price:34.99},
                        {id:"47873904509236", title:"Humminbird Solix & Helix 15\" & Onix & 800-900 Series", price:34.99}
                      ],
                      why:"Billet aluminum replacement knobs, knurled grip, 2-pack." },
    cableSleeve:   { name:"Cable Sleeve", handle:"cable-sleeve", price:44.99, variantId:"47349588263220",
                      image:CDN+"cablewrap.jpg?v=1704215652",
                      why:"Wraps transducer and power cables running to your graphs — 4ft sections." },
    transomSaver:  { name:"BD Transom Saver", handle:"transom-saver", price:129.99, variantId:"48910423589172",
                      image:CDN+"TransomSaverIso2_ad6d0dda-7281-4c8a-878a-59257c3cede5.png?v=1770143977",
                      why:"Protects your transom and outboard during trailering." },
    steeringClips: { name:"BD Steering Clips", handle:"steering-clips", price:49.99, variantId:"48997142069556",
                      image:CDN+"SteeringClip2.png?v=1770149578",
                      why:"Secures your hydraulic steering system during transport." }
  };

  // Real Sport Track gunnel-system variants — the product only fits Lund, Tracker,
  // and Alumacraft integrated tracks, each combined with an arm size. The
  // question shown to the customer is filtered to their selected boat brand
  // (state.boatBrand) so a Lund shopper never sees Tracker/Alumacraft options
  // and vice versa. Alumacraft only comes in one size — no 4x4 exists for it.
  const SPORT_TRACK_VARIANTS = {
    "Lund 42° / 4x8":  { variantId:"48909120733492", price:620.00 },
    "Lund 42° / 4x4":  { variantId:"48604190081332", price:620.00 },
    "Lund 90° / 4x8":  { variantId:"48909120799028", price:620.00 },
    "Lund 90° / 4x4":  { variantId:"48909120766260", price:620.00 },
    "Tracker Versa Track / 4x8": { variantId:"48909120864564", price:620.00 },
    "Tracker Versa Track / 4x4": { variantId:"48909120831796", price:620.00 },
    "Alumacraft / 4x8": { variantId:"49207315398964", price:620.00 }
  };

  // Which gunnel-system option keys to offer, based on the customer's boat
  // brand from Step 1. We only carry Lund and Alumacraft integrated-track
  // fitments — anyone else gets a skip path back to the other mounting
  // methods instead of being pushed into a fit that may not exist for them.
  // Arm size defaults to 4x8 (the standard size) rather than asking — 4x4 is
  // still available on the product page for anyone who needs it.
  function gunnelOptionsForBrand(){
    if(state.boatBrand === "Lund") return ["Lund 42° / 4x8","Lund 90° / 4x8"];
    if(state.boatBrand === "Alumacraft") return ["Alumacraft / 4x8"];
    return [];
  }

  // Real BD Commander variants — count (Single/Double) x height. Only 17" comes in Double.
  const COMMANDER_VARIANTS = {
    "1-17": {variantId:"49144693817652", price:1249.99}, "1-19": {variantId:"49207364092212", price:1249.99}, "1-22": {variantId:"49207583473972", price:1249.99},
    "2-17": {variantId:"49144693850420", price:1499.99}
  };

  function withVariant(base, override){
    return Object.assign({}, base, override);
  }

  /* Full bundled catalog snapshot — used as the primary source so brand
     matching and the model picker work everywhere (including previews
     where the live same-origin fetch can't run). A live fetch is still
     attempted on top of this and any new matches get appended, so the
     page stays current once it's actually deployed on-domain. */
  const LEVELING_PLATES = [
    {brand:"Skeeter", label:"FXR / ZXR", handle:"leveling-plate-skeeter-fxr-zxr", price:319.99},
    {brand:"Phoenix", label:"Elite / ZXL", handle:"leveling-plate-phoenix-elite", price:319.99},
    {brand:"Ranger", label:"Cup Boat", handle:"leveling-plate-ranger-cup-boat", price:349.99},
    {brand:"Vexus", label:"DVX", handle:"leveling-plate-vexus-dvx", price:319.99},
    {brand:"Vexus", label:"AVX", handle:"leveling-plate-vexus-avx", price:319.99},
    {brand:"Ranger", label:"R Boat", handle:"leveling-plate-ranger-r-boat", price:374.99},
    {brand:"Nitro", label:"Z20 & Z21", handle:"leveling-plate-nitro-z20-copy", price:374.99},
    {brand:"Ranger", label:"L Boat", handle:"leveling-plate-ranger-l-boat", price:349.99},
    {brand:"Vexus", label:"Standard", handle:"leveling-plate-vexus", price:319.99},
    {brand:"Skeeter", label:"ZX 150 / 250", handle:"leveling-plate-skeeter-zx-150", price:319.99},
    {brand:"Nitro", label:"Z18 & Z19", handle:"leveling-plate-nitro-z20-z21-copy", price:374.99},
    {brand:"Ranger", label:"Pro 620 / 621 / 622", handle:"leveling-plate-ranger-622", price:319.99},
    {brand:"Triton", label:"Standard", handle:"triton-leveling-plate", price:319.99},
    {brand:"Lund", label:"Standard", handle:"leveling-plate-lund", price:319.99},
    {brand:"Phoenix", label:"721 Pro XP", handle:"leveling-plate-phoenix-721-pro-xp", price:319.99},
    {brand:"Skeeter", label:"WX (Flange Holes)", handle:"skeeter-wx-with-flange-holes", price:319.99},
    {brand:"Ranger", label:"2023 RT 188p", handle:"ranger-2023-rt-188p", price:319.99},
    {brand:"Ranger", label:"1880 Angler", handle:"leveling-plate-ranger-1880", price:319.99},
    {brand:"Phoenix", label:"Pro 818 & 819", handle:"leveling-plate-phoenix-818-819", price:319.99},
    {brand:"Caymas", label:"Standard", handle:"copy-of-leveling-plate-caymas-1", price:319.99},
    {brand:"Falcon", label:"2024", handle:"leveling-plate-falcon-2024", price:319.99},
    {brand:"Caymas", label:"Alt 2", handle:"copy-of-leveling-plate-caymas-3", price:319.99},
    {brand:"Skeeter", label:"ZXE", handle:"leveling-plate-skeeter-zxe", price:319.99},
    {brand:"Ikon", label:"Standard", handle:"ikon-assembly", price:319.99},
    {brand:"Caymas", label:"27º (7 or 13 hole)", handle:"caymas-27", price:319.99},
    {brand:"Legend", label:"Standard", handle:"copy-of-leveling-plate-legend-1", price:319.99},
    {brand:"Phoenix", label:"XE", handle:"leveling-plate-phoenix-xe", price:319.99},
    {brand:"Ranger", label:"620", handle:"leveling-plate-ranger-620", price:319.99},
    {brand:"Ranger", label:"1880 Multi Species", handle:"leveling-plate-ranger-1880-multi-species", price:319.99},
    {brand:"Falcon", label:"195", handle:"leveling-plate-falcon-195", price:319.99},
    {brand:"Phoenix", label:"2024 ZXL 819", handle:"leveling-plate-phoenix-2024-zxl-819", price:319.99},
    {brand:"Yarcraft", label:"910", handle:"leveling-plate-yarcraft-910", price:319.99},
    {brand:"Triton", label:"206 Fish Hunter", handle:"leveling-plate-triton-206-fish-hunter", price:319.99},
    {brand:"Ranger", label:"522", handle:"leveling-plate-ranger-522", price:319.99},
    {brand:"Warrior", label:"Standard", handle:"leveling-plate-warrior", price:319.99},
    {brand:"Triton", label:"2024", handle:"triton-2024", price:319.99},
    {brand:"Ranger", label:"2020 198p", handle:"ranger-2020-198p", price:319.99},
    {brand:"Ranger", label:"621", handle:"ranger-621", price:319.99},
    {brand:"Caymas", label:"DVX", handle:"copy-of-leveling-plate-caymas-dvx-1", price:319.99},
    {brand:"Ranger", label:"621VS Fisherman", handle:"leveling-plate-ranger-621vs-fisherman", price:319.99},
    {brand:"Skeeter", label:"WXR", handle:"leveling-plate-skeeter-wxr", price:319.99},
    {brand:"Vexus", label:"ADX 200 & AXE 180", handle:"leveling-plate-vexus-adx-200-axe-180", price:319.99},
    {brand:"Caymas", label:"DV22", handle:"leveling-plate-caymas-dvx-copy", price:319.99},
    {brand:"Nitro", label:"ZV21", handle:"leveling-plate-nitro-zv21", price:374.99},
    {brand:"Legend", label:"V20", handle:"leveling-plate-legend-copy", price:319.99},
    {brand:"Ikon", label:"VLX", handle:"leveling-plate-ikon-vlx", price:319.99},
    {brand:"Ranger", label:"Z175 (2016)", handle:"leveling-plate-ranger-z175-2016", price:319.99},
    {brand:"Allison", label:"2026 Pro Sport", handle:"2026-allison-pro-sport", price:319.99},
    {brand:"Ranger", label:"618 Tiller", handle:"leveling-plate-ranger-618-tiller", price:319.99},
    {brand:"Ranger", label:"2013 619VS", handle:"leveling-plate-ranger-2013-619vs", price:319.99},
    {brand:"Vexus", label:"DVX 23S", handle:"leveling-plate-vexus-dvx-23s", price:349.99},
    {brand:"Alumacraft", label:"195X Competitor", handle:"leveling-plate-alumacraft-195x-competitor", price:319.99},
    {brand:"Lund", label:"2025 GL Tyee", handle:"leveling-plate-2025-lund-gl-tyee", price:319.99},
    {brand:"Triton", label:"2019 TRX 189", handle:"leveling-plate-2019-triton-trx-189", price:319.99},
    {brand:"Ranger", label:"2026 212", handle:"leveling-plate-ranger", price:319.99},
    {brand:"Charger", label:"Elite", handle:"copy-of-leveling-plate-charger-elite", price:319.99}
  ];

  const CONSOLE_PLATES = [
    {brand:"Ranger", label:"2026 519R", handle:"2026-ranger-519r-console-plate", price:129.99},
    {brand:"Skeeter", label:"2026 ZXE", handle:"console-plate-2026-skeeter-zxe", price:119.00},
    {brand:"Charger", label:"203 Elite", handle:"console-plate-charger-203-elite", price:129.99},
    {brand:"Ranger", label:"520 Small Dash", handle:"console-plate-ranger-520-small-dash", price:129.99},
    {brand:"Ranger", label:"L", handle:"console-plate-ranger-l", price:129.99},
    {brand:"Express", label:"2022", handle:"console-plate-express-2022", price:129.99},
    {brand:"Ranger", label:"Cup", handle:"console-plate-ranger-cup", price:129.99},
    {brand:"Skeeter", label:"Version 2", handle:"console-plate-skeeter-version-2", price:129.99},
    {brand:"Skeeter", label:"FXR / ZXR (Version 1)", handle:"console-plate-skeeter-fxr-zxr", price:129.99},
    {brand:"Triton", label:"20 XP", handle:"console-plate-triton-20-xp", price:129.99},
    {brand:"Vexus", label:"AVX 1880/1980/2080 (Before 2022)", handle:"console-plate-vexus-avx-1880-1980-2080-before-2022", price:129.99},
    // Universal sized plates — not boat-specific, used as the fallback when no brand match exists
    {brand:null, label:"6\" x 8\"", handle:"console-plate-6-x-8", price:129.99},
    {brand:null, label:"6\" x 10\"", handle:"console-plate-6-x-10", price:129.99},
    {brand:null, label:"6\" x 10\" (Rounded Corners)", handle:"console-plate-6-x-10-rounded-corners", price:129.99},
    {brand:null, label:"7\" x 9.25\"", handle:"console-plate-7-x-9-3-4", price:129.99},
    {brand:null, label:"8\" x 11\"", handle:"console-plate-8-x-11", price:129.99},
    {brand:null, label:"9\" x 12.75\"", handle:"console-plate-9-x-12-3-4", price:129.99},
    {brand:null, label:"9\" x 14\"", handle:"console-plate-9-x-14", price:129.99},
    {brand:null, label:"9\" x 15\"", handle:"console-plate-9-x-15", price:129.99},
    {brand:null, label:"9.25\" x 15.25\"", handle:"console-plate-9-1-4-x-15-1-4", price:129.99}
  ];

  const UNIVERSAL_CONSOLE_PLATES = CONSOLE_PLATES.filter(p => p.brand === null);
  const LEVELING_PLATE_BRANDS = Array.from(new Set(LEVELING_PLATES.map(p=>p.brand))).sort();
  const CONSOLE_PLATE_BRANDS = Array.from(new Set(CONSOLE_PLATES.filter(p=>p.brand).map(p=>p.brand))).sort();
  // Full brand list offered in the picker (superset, plus "Other"). This is the
  // fallback/seed used until (and unless) the live tag-based brand list below
  // resolves — e.g. if previewing off-domain, or on first paint before the
  // fetch completes.
  const ALL_BRANDS = Array.from(new Set([...LEVELING_PLATE_BRANDS, ...CONSOLE_PLATE_BRANDS])).sort();
  // Live-discovered brand list, populated by fetchLiveBrands() below. Once set,
  // this — not ALL_BRANDS — drives the boat-brand dropdown.
  let LIVE_BRANDS = null;
  // Tags that describe the product category rather than a boat brand. Any tag
  // on a leveling/console plate that ISN'T one of these (and doesn't match the
  // generic-keyword filter below) is treated as a brand.
  const NON_BRAND_TAGS = ["leveling plate","console plate","mounting options","mounting plate",
    "accessories","console mount","console mounts","bow mounts","bow mount","hardware"];
  // Defense-in-depth: real boat brands (Ranger, Lund, Skeeter...) are proper
  // nouns and never contain words like these — category/product-type tags
  // often do. Catches new category tags added later without needing a code
  // update every time, on top of the exact-match list above.
  const NON_BRAND_KEYWORDS = ["mount","accessor","hardware","option","plate","series","bracket"];
  function looksLikeBrandTag(tag){
    const lower = tag.toLowerCase();
    if(NON_BRAND_TAGS.includes(lower)) return false;
    return !NON_BRAND_KEYWORDS.some(kw => lower.includes(kw));
  }

  const TROLLING_MOTOR_BRANDS = ["Minn Kota","Garmin","Lowrance","MotorGuide","Other / not sure"];

  /* =========================================================
     STATE
     ========================================================= */
  const state = {
    step: "boat",          // boat | bow | console | livescope | results
    boatBrand: null,

    bow: {
      count: null,          // "0" | "1" | "2" | "3"
      bigScreen: null,      // bool — Garmin 9000-series, no factory gimbal
      commanderSize: null,  // "17" | "19" | "22" — Commander cradle size, matches the unit's screen size (not mount height)
      largeUnit: null,      // bool — any unit larger than 12"
      height: null,         // "low" | "mid" | "high"
      feature: null,        // "layFlat" | "lowerToDeck" | "raiseLower" — what the customer wants the mount to do
      layFlatType: null,    // "standard" | "hybrid" — Flex vs BD Hybrid, only asked when feature === "layFlat"
      quickRelease: null,   // bool
      plateStatus: null,    // "matched" | "manual"
      plateProduct: null,
      manualPosition: null  // "pedal" | "side"
    },
    console: {
      count: null,
      surface: null,        // "flat" | "shelf"
      plateStatus: null,    // "matched" | "equipped" | "universal"
      plateProduct: null
    },
    liveScope: {
      uses: null,            // bool
      location: null,        // "trolling" | "pole"
      tmBrand: null,
      tmModel: null,          // "Force" | "Kraken" for Garmin
      poleStyle: null,        // "fixed" | "breakaway"
      poleDualMode: null,     // bool — breakaway pole that can also run fixed
      poleMount: null,        // "direct" | "track" | "gunnel"
      poleGunnelSystem: null, // "Lund 42°" | "Lund 90°" | "Tracker Versa Track"
      poleProduct: null       // resolved product for the pole path
    }
  };

  const panel = document.getElementById("bd-app-panel");
  const manifestEl = document.getElementById("bd-app-manifest");

  /* =========================================================
     LIVE CATALOG LOOKUPS (same-origin once embedded on-site)
     Falls back gracefully to a manual picker if the fetch
     can't run (e.g. previewed off-domain).
     ========================================================= */
  async function fetchCollectionProducts(handle){
    try{
      const res = await fetch(`${SITE}/collections/${handle}/products.json?limit=250`, {mode:"cors"});
      if(!res.ok) throw new Error("bad response");
      const data = await res.json();
      return data.products || [];
    }catch(e){
      return null; // signals "couldn't reach live data"
    }
  }

  // Shopify's public product JSON returns tags as a comma-separated string;
  // normalize to an array either way.
  function productTags(p){
    if(Array.isArray(p.tags)) return p.tags;
    if(typeof p.tags === "string") return p.tags.split(",").map(t=>t.trim()).filter(Boolean);
    return [];
  }

  async function findBoatMatches(collectionHandle, brand){
    const products = await fetchCollectionProducts(collectionHandle);
    if(!products) return null;
    const brandLower = brand.toLowerCase();
    // Prefer an exact tag match — reliable now that plates are brand-tagged.
    const tagMatches = products.filter(p => productTags(p).some(t => t.toLowerCase() === brandLower));
    if(tagMatches.length) return tagMatches;
    // Fall back to title matching for anything not yet tagged (e.g. console plates).
    return products.filter(p => p.title.toLowerCase().includes(brandLower));
  }

  // Builds the live boat-brand list by reading actual tags off both plate
  // collections — any tag that isn't a known category tag is treated as a
  // brand. New brands show up automatically here the moment products carrying
  // that brand tag exist, no code change required. Falls back silently (keeps
  // ALL_BRANDS as-is) if the live fetch can't complete.
  async function fetchLiveBrands(){
    const [leveling, console_] = await Promise.all([
      fetchCollectionProducts("leveling-plates"),
      fetchCollectionProducts("console-plates")
    ]);
    const found = new Set();
    [...(leveling||[]), ...(console_||[])].forEach(p=>{
      productTags(p).forEach(t=>{
        if(t && looksLikeBrandTag(t)) found.add(t);
      });
    });
    if(!found.size) return null;
    return Array.from(found).sort();
  }

  function refreshBrandDropdownIfPresent(){
    const select = document.getElementById("bd-app-brand-select");
    if(!select) return; // customer has already moved past the boat step
    const current = select.value;
    const brands = LIVE_BRANDS && LIVE_BRANDS.length ? LIVE_BRANDS : ALL_BRANDS;
    select.innerHTML = `<option value="">Select a brand…</option>
      ${brands.map(b=>`<option value="${b}">${b}</option>`).join("")}
      <option value="__other">Other / not listed</option>`;
    if(brands.includes(current) || current === "__other") select.value = current;
    const next = document.getElementById("bd-app-boat-next");
    if(next) next.disabled = !select.value;
  }

  // Fetches full product JSON (price, image, numeric variant id) for a single
  // handle — used to enrich boat-specific plate matches with real cart/image
  // data at results time, since we only ever need this for the 1-2 plates
  // a given customer actually matched, not the full 76-plate catalog.
  const productDetailsCache = {};
  async function fetchProductJSON(handle){
    if(productDetailsCache[handle]) return productDetailsCache[handle];
    try{
      const res = await fetch(`${SITE}/products/${handle}.json`, {mode:"cors"});
      if(!res.ok) throw new Error("bad response");
      const data = await res.json();
      const allVariants = (data.product && data.product.variants) || [];
      const variant = allVariants[0];
      const image = data.product && data.product.images && data.product.images[0];
      const result = {
        price: variant ? parseFloat(variant.price) : null,
        variantId: variant ? String(variant.id) : null,
        image: image ? image.src : null,
        // Full variant list so the UI can offer a picker when there's more than one
        // real option (switch type, hand orientation, etc.) instead of silently
        // guessing the first one.
        variants: allVariants.map(v => ({ id: String(v.id), title: v.title, price: parseFloat(v.price) }))
      };
      productDetailsCache[handle] = result;
      return result;
    }catch(e){
      return null; // signals "couldn't reach live data" — e.g. previewing off-domain
    }
  }

  // Enriches a plate match ({brand,label,handle,price}) with a real image and
  // variant id so it can render as a genuine, addable card. Falls back to the
  // static price alone (no image, no direct add-to-cart) if the fetch fails.
  // Refreshes price/image/variant data live from the store for any product
  // (core mount or boat plate) that has a handle. If the product already
  // carries a specific resolved variantId (e.g. Console Mount Dual, Commander
  // Double/17"), this matches that same variant in the live data instead of
  // defaulting to whichever variant Shopify lists first — critical for
  // multi-variant products where position isn't meaningful. Falls back to
  // the baked-in seed values untouched if the live fetch can't complete
  // (e.g. previewing off-domain, or a transient network issue).
  async function resolveProductLive(product){
    if(!product || !product.handle) return product;
    const details = await fetchProductJSON(product.handle);
    if(!details) return product;

    let price = details.price, variantId = details.variantId;
    if(product.variantId && details.variants){
      const match = details.variants.find(v => v.id === product.variantId);
      if(match){ price = match.price; variantId = match.id; }
    }

    let variants = product.variants || null;
    if(variants && details.variants){
      // Refresh live price on each option in an existing picker list, matched by id.
      variants = variants.map(v => {
        const live = details.variants.find(lv => lv.id === v.id);
        return live ? Object.assign({}, v, { price: live.price }) : v;
      });
    }else if(!variants && details.variants && details.variants.length > 1 && !product.variantId){
      variants = details.variants;
    }

    return Object.assign({}, product, {
      price: price != null ? price : product.price,
      variantId: variantId || product.variantId,
      image: details.image || product.image,
      variants: variants
    });
  }

  /* =========================================================
     HELPERS
     ========================================================= */
  function productUrl(p){
    if(p.handle) return `${SITE}/products/${p.handle}`;
    if(p.collection) return `${SITE}/collections/${p.collection}`;
    return SITE;
  }
  function priceLabel(p){
    return (p.price != null) ? `$${p.price.toFixed(2)}` : "See current price";
  }

  const STEP_ORDER = ["boat","bow","console","livescope","results"];
  // Which zone photo to show for each step. LiveScope reuses the trolling-motor
  // shot since that's the relevant area for both the shaft and pole paths;
  // results reuses the full-boat default now that everything's picked.
  const ZONE_STEP_MAP = { boat:"boat", bow:"bow", console:"console", livescope:"livescope", results:"boat" };

  function updateManifest(){
    manifestEl.querySelectorAll("li").forEach(li=>{
      const s = li.dataset.step;
      const sIdx = STEP_ORDER.indexOf(s);
      li.classList.toggle("is-current", s === state.step);
      li.classList.toggle("is-complete", sIdx < furthestStepIndex);
      li.classList.toggle("is-reachable", sIdx <= furthestStepIndex);
      li.querySelector(".check").textContent = sIdx < furthestStepIndex ? "✓" : "";
    });
  }

  function updateZoneImage(){
    const wrap = document.getElementById("bd-app-zone-image");
    const img = document.getElementById("bd-app-zone-image-img");
    if(!wrap || !img) return;
    const key = ZONE_STEP_MAP[state.step];
    const src = window.BD_ZONE_IMAGES && window.BD_ZONE_IMAGES[key];
    if(!src){
      wrap.classList.remove("has-image");
      img.classList.remove("is-loaded");
      img.removeAttribute("src");
      return;
    }
    const labels = { boat:"Full boat overview", bow:"Bow of the boat", console:"Console area", livescope:"Trolling motor area" };
    img.alt = labels[key] || "";
    img.classList.remove("is-loaded");
    img.onload = () => img.classList.add("is-loaded");
    img.src = src;
    wrap.classList.add("has-image");
  }

  // Lets a customer jump back to any step they've already passed (or the
  // current one) from the progress list — e.g. back into the questions from
  // the build sheet. Steps not yet reached aren't clickable, since jumping
  // ahead would skip questions the recommendation logic depends on.
  function setupManifestNav(){
    manifestEl.querySelectorAll("li").forEach(li=>{
      const step = li.dataset.step;
      const btn = li.querySelector(".bd-manifest-btn");
      btn.addEventListener("click", ()=>{
        const targetIdx = STEP_ORDER.indexOf(step);
        if(targetIdx !== -1 && targetIdx <= furthestStepIndex) go(step);
      });
    });
  }

  // Tracks the furthest step a customer has ever reached, so that finishing
  // an edit to an earlier section (via the manifest links) can skip back
  // ahead to wherever they actually left off, instead of forcing them to
  // re-click through every later section again. Manifest clicks and "back"
  // buttons always land exactly where clicked — this only affects a
  // section's own natural "I'm done, move on" transitions.
  let furthestStepIndex = 0;

  // Boat-specific answers (leveling/console plate matches especially) don't
  // carry over to a different boat — if the brand changes after the
  // customer has already answered later questions, wipe those answers
  // clean rather than leave a stale plate match sitting around for the
  // wrong boat.
  function resetDownstreamState(){
    Object.assign(state.bow, {
      count: null, bigScreen: null, commanderSize: null, largeUnit: null, height: null,
      feature: null, layFlatType: null, quickRelease: null, plateStatus: null,
      plateProduct: null, manualPosition: null
    });
    Object.assign(state.console, {
      count: null, surface: null, plateStatus: null, plateProduct: null
    });
    Object.assign(state.liveScope, {
      uses: null, location: null, tmBrand: null, tmModel: null, poleStyle: null,
      poleDualMode: null, poleMount: null, poleGunnelSystem: null, poleProduct: null
    });
    furthestStepIndex = 0;
  }

  function go(step){
    state.step = step;
    const idx = STEP_ORDER.indexOf(step);
    if(idx > furthestStepIndex) furthestStepIndex = idx;
    updateManifest();
    updateZoneImage();
    render();
    window.scrollTo({top:0, behavior:"smooth"});
  }

  function goForward(nextStep){
    trackStepComplete(state.step);
    const nextIdx = STEP_ORDER.indexOf(nextStep);
    go(furthestStepIndex > nextIdx ? STEP_ORDER[furthestStepIndex] : nextStep);
  }

  function boatLabel(){
    return state.boatBrand === "Other" ? "your boat" : state.boatBrand;
  }

  function el(html){
    const t = document.createElement("template");
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  /* =========================================================
     ANALYTICS (window.dataLayer only)
     Exposes what happens inside the builder as flat dataLayer events for
     GTM. Never loads GA/GTM, never calls gtag(), and never fires the
     standard add_to_cart / begin_checkout / purchase events — Shopify's
     own GA4 integration stays the source of truth for ecommerce.
     Everything here is wrapped so a tracking failure can never break the
     builder. Only boat/electronics/product data is sent — no customer data.
     ========================================================= */

  // Every parameter key this builder ever pushes. GTM merges each push into
  // one persistent data model, so a key from an earlier event (e.g. Bow's
  // bow_mount_height) would otherwise leak into later events that don't set
  // it. Each push explicitly clears the keys it isn't using.
  const BB_PARAM_KEYS = [
    "builder_location", "step_number", "step_name",
    "boat_brand", "boat_model", "boat_fit_type",
    "bow_graph_count", "bow_graph_size", "bow_graph_brand", "bow_graph_model",
    "bow_mount_height", "bow_mount_feature", "bow_lay_flat_type", "bow_quick_release",
    "bow_plate_status", "bow_manual_position", "bow_mount", "bow_mount_id", "bow_plate",
    "console_graph_count", "console_surface", "console_plate_status", "console_plate_model",
    "console_mount", "console_mount_id", "console_plate",
    "ffs_used", "ffs_mount_location", "ffs_trolling_motor_brand", "ffs_trolling_motor_model",
    "ffs_pole_style", "ffs_pole_dual_mode", "ffs_pole_mount", "ffs_gunnel_system",
    "ffs_mount", "ffs_mount_id", "ffs_pole", "ffs_pole_id",
    "accessories", "upgrade_selected", "build_value", "item_count"
  ];

  function trackBoatBuilderEvent(eventName, parameters = {}){
    try{
      window.dataLayer = window.dataLayer || [];
      const payload = { event: eventName };
      BB_PARAM_KEYS.forEach(k => { payload[k] = undefined; });
      Object.keys(parameters).forEach(k => {
        if(parameters[k] !== undefined && parameters[k] !== null && parameters[k] !== "") payload[k] = parameters[k];
      });
      window.dataLayer.push(payload);
    }catch(e){ /* analytics must never break the builder */ }
  }

  const tracked = {
    view: false,
    start: false,
    steps: {},          // step -> signature of the last selections sent
    completeSig: null   // signature of the last build sheet sent
  };

  // Private, non-PII ID tying Shopify cart lines back to one build sheet's add
  // action — every line in that add carries the same ID, and it's what lets an
  // uncertain add be checked against the live cart instead of re-sent.
  // Shopify-only (line item property) — deliberately never sent to GA4.
  function newBuildId(){
    return "BB-" + Date.now().toString(36).toUpperCase() + "-" + Math.random().toString(36).slice(2, 6).toUpperCase();
  }

  const STEP_LABELS = { boat: "your_boat", bow: "bow", console: "console", livescope: "livescope" };

  function yesNo(v){ return v === true ? "yes" : v === false ? "no" : undefined; }

  function builderLocation(){
    const path = window.location.pathname.replace(/\/+$/, "");
    const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/").replace(/\/+$/, "");
    const rel = path.slice(root.length) || "/";
    if(rel === "/" || rel === "") return "homepage";
    if(/^\/pages\/boat-builder$/.test(rel)) return "dedicated_page";
    return "other";
  }

  // Mirrors the builder's own decision tree so only answers that are live on
  // the path the customer actually took are sent — answers left over from a
  // path they backed out of stay in state but are ignored here, exactly as
  // pickBowMount()/pickConsoleMount()/pickLiveScopeMount() ignore them.
  function boatModelFromPlates(){
    if(state.bow.count && state.bow.count !== "0" && state.bow.plateStatus === "matched" && state.bow.plateProduct) return state.bow.plateProduct.label;
    if(state.console.count && state.console.count !== "0" && state.console.surface === "flat" && state.console.plateStatus === "matched" && state.console.plateProduct) return state.console.plateProduct.label;
    return undefined;
  }

  function boatFitType(){
    const bowActive = state.bow.count && state.bow.count !== "0";
    const consoleNeedsPlate = state.console.count && state.console.count !== "0" && state.console.surface === "flat";
    if(!bowActive && !consoleNeedsPlate) return "not_applicable";
    const bowMatched = bowActive && state.bow.plateStatus === "matched";
    const consoleMatched = consoleNeedsPlate && state.console.plateStatus === "matched";
    return bowMatched || consoleMatched ? "boat_specific" : "universal";
  }

  function bowFields(){
    const b = state.bow;
    if(b.count === null) return {};
    const f = { bow_graph_count: parseInt(b.count, 10) };
    if(b.count === "0") return f;
    if(b.count !== "3"){
      if(b.bigScreen){
        f.bow_graph_size = b.commanderSize;
        f.bow_graph_brand = "Garmin";
        f.bow_graph_model = "9000 series";
      }else{
        f.bow_graph_size = b.largeUnit ? "12_or_larger" : "under_12";
        f.bow_mount_height = b.height;
        f.bow_mount_feature = b.feature;
        if(b.feature === "layFlat") f.bow_lay_flat_type = b.layFlatType;
        if(b.feature === "lowerToDeck" && b.height === "high") f.bow_quick_release = yesNo(b.quickRelease);
      }
    }
    f.bow_plate_status = b.plateStatus;
    if(b.plateStatus === "matched" && b.plateProduct){
      f.boat_model = b.plateProduct.label;
      f.bow_plate = normalizeProduct(b.plateProduct).name;
    }else if(b.plateStatus === "manual"){
      f.bow_manual_position = b.manualPosition;
      f.bow_plate = (b.manualPosition === "pedal" ? PRODUCTS.bridge : PRODUCTS.mountingPlate).name;
    }
    const mount = pickBowMount().primary;
    if(mount){ f.bow_mount = mount.name; f.bow_mount_id = mount.variantId; }
    return f;
  }

  function consoleFields(){
    const c = state.console;
    if(c.count === null) return {};
    const f = { console_graph_count: parseInt(c.count, 10) };
    if(c.count === "0") return f;
    f.console_surface = c.surface;
    if(c.surface === "flat"){
      f.console_plate_status = c.plateStatus;
      if((c.plateStatus === "matched" || c.plateStatus === "universal") && c.plateProduct){
        f.console_plate_model = c.plateProduct.label;
        f.console_plate = normalizeProduct(c.plateProduct).name;
      }
    }
    const mount = pickConsoleMount()[0];
    if(mount){ f.console_mount = mount.name; f.console_mount_id = mount.variantId; }
    return f;
  }

  function liveScopeFields(){
    const ls = state.liveScope;
    if(ls.uses === null) return {};
    const f = { ffs_used: yesNo(ls.uses) };
    if(!ls.uses) return f;
    f.ffs_mount_location = ls.location;
    if(ls.location === "trolling"){
      f.ffs_trolling_motor_brand = ls.tmBrand;
      if(ls.tmBrand === "Garmin") f.ffs_trolling_motor_model = ls.tmModel;
    }else if(ls.location === "pole"){
      f.ffs_pole_style = ls.poleStyle;
      if(ls.poleStyle === "breakaway") f.ffs_pole_dual_mode = yesNo(ls.poleDualMode);
      f.ffs_pole_mount = ls.poleMount;
      if(ls.poleMount === "gunnel") f.ffs_gunnel_system = ls.poleGunnelSystem;
    }
    const m = pickLiveScopeMount();
    if(ls.location === "pole"){
      if(m.primary){ f.ffs_pole = m.primary.name; f.ffs_pole_id = m.primary.variantId; }
      if(m.secondary){ f.ffs_mount = m.secondary.name; f.ffs_mount_id = m.secondary.variantId; }
    }else if(m.primary){
      f.ffs_mount = m.primary.name; f.ffs_mount_id = m.primary.variantId;
    }
    return f;
  }

  function stepFields(step){
    if(step === "boat") return { boat_brand: state.boatBrand };
    if(step === "bow") return Object.assign({ boat_brand: state.boatBrand }, bowFields());
    if(step === "console") return Object.assign({ boat_brand: state.boatBrand }, consoleFields());
    if(step === "livescope") return Object.assign({ boat_brand: state.boatBrand }, liveScopeFields());
    return null;
  }

  function observeBuilderView(){
    try{
      const target = (panel && panel.closest(".bd-app")) || panel;
      if(!target) return;
      if(!("IntersectionObserver" in window)){ trackBuilderView(); return; }
      // Counts as viewed once a meaningful slice of the builder is on screen
      // in a visible tab: half the builder, or 30% of the viewport's height
      // for a builder taller than the screen.
      let inView = false;
      const check = ()=>{
        if(inView && document.visibilityState === "visible"){
          trackBuilderView();
          io.disconnect();
          document.removeEventListener("visibilitychange", check);
        }
      };
      const io = new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          const needed = Math.min(entry.boundingClientRect.height * 0.5, window.innerHeight * 0.3);
          inView = entry.isIntersecting && entry.intersectionRect.height >= needed;
        });
        check();
      }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
      // A tab opened in the background only counts once it's actually shown.
      document.addEventListener("visibilitychange", check);
      io.observe(target);
    }catch(e){ /* analytics must never break the builder */ }
  }

  function trackBuilderView(){
    if(tracked.view) return;
    tracked.view = true;
    trackBoatBuilderEvent("boat_builder_view", { builder_location: builderLocation() });
  }

  function trackBuilderStart(){
    if(tracked.start) return;
    tracked.start = true;
    // Interacting with the builder proves it was seen, even if the visibility
    // observer hasn't reported yet — keeps view ≥ start in the funnel.
    trackBuilderView();
    trackBoatBuilderEvent("boat_builder_start", { builder_location: builderLocation() });
  }

  // Called only from goForward(), i.e. when a step's own "done" transition
  // advances the customer — never on back buttons, manifest jumps, or
  // individual option clicks within a step. Re-advancing through a step with
  // identical answers does not fire again; changed answers do.
  function trackStepComplete(step){
    try{
      const fields = stepFields(step);
      if(!fields) return;
      const sig = JSON.stringify(fields);
      if(tracked.steps[step] === sig) return;
      tracked.steps[step] = sig;
      trackBoatBuilderEvent("boat_builder_step_complete", Object.assign({
        step_number: STEP_ORDER.indexOf(step) + 1,
        step_name: STEP_LABELS[step]
      }, fields));
    }catch(e){ /* analytics must never break the builder */ }
  }

  // Flat configuration + build-sheet snapshot for the complete / add-to-cart
  // events. Kept to ~20 parameters (GA4 allows 25 per event); per-step detail
  // such as mount height, features, pole style and product IDs stays in the
  // step_complete events.
  function buildSnapshot(items, isSelected){
    const bow = bowFields(), con = consoleFields(), ls = liveScopeFields();
    const chosen = items.filter(isSelected);
    const find = test => { const it = chosen.find(test); return it ? it.product.name : undefined; };
    const isPole = state.liveScope.location === "pole";
    let value = 0;
    chosen.forEach(it => { if(it.product.price != null) value += it.product.price; });
    const accessories = chosen.filter(it => it.group === "Accessories").map(it => it.id.replace(/^acc-/, ""));
    return {
      boat_brand: state.boatBrand,
      boat_model: boatModelFromPlates(),
      boat_fit_type: boatFitType(),
      bow_graph_count: bow.bow_graph_count,
      bow_graph_size: bow.bow_graph_size,
      console_graph_count: con.console_graph_count,
      console_surface: con.console_surface,
      ffs_used: ls.ffs_used,
      ffs_mount_location: ls.ffs_mount_location,
      bow_mount: find(it => it.id === "bow-0" || it.radioGroup === "bow-mount"),
      bow_plate: find(it => it.id === "bow-plate"),
      console_mount: find(it => it.id === "console-0"),
      console_plate: find(it => it.id === "console-plate"),
      ffs_pole: isPole ? find(it => it.id === "ls-0" || it.radioGroup === "ls-mount") : undefined,
      ffs_mount: isPole ? find(it => it.id === "ls-1") : find(it => it.id === "ls-0"),
      accessories: accessories.length ? accessories.join(",") : "none",
      upgrade_selected: yesNo(chosen.some(it => it.group === "Upgraded Options")),
      build_value: Math.round(value * 100) / 100,
      item_count: chosen.length
    };
  }

  function trackBuilderComplete(items, selection){
    try{
      const snapshot = buildSnapshot(items, it => !!selection[it.id]);
      const sig = JSON.stringify(snapshot);
      if(tracked.completeSig === sig) return;
      tracked.completeSig = sig;
      trackBoatBuilderEvent("boat_builder_complete", snapshot);
    }catch(e){ /* analytics must never break the builder */ }
  }

  // addedItems: the builder items Shopify confirmed; cartLines: the matching
  // cart lines, whose prices/quantities are what actually went into the cart.
  function trackBuilderAddToCart(addedItems, cartLines){
    try{
      const snapshot = buildSnapshot(addedItems, ()=>true);
      if(cartLines && cartLines.length){
        let cents = 0, qty = 0;
        cartLines.forEach(l => { qty += l.quantity; cents += l.price * l.quantity; });
        snapshot.build_value = Math.round(cents) / 100;
        snapshot.item_count = qty;
      }
      trackBoatBuilderEvent("boat_builder_add_to_cart", snapshot);
    }catch(e){ /* analytics must never break the builder */ }
  }

  /* =========================================================
     RENDER: BOAT STEP
     ========================================================= */
  function renderBoat(){
    panel.innerHTML = "";
    panel.appendChild(el(`
      <div>
        <p class="bd-eyebrow">Step 1 of 5</p>
        <h1 class="bd-h1">What are we rigging out?</h1>
        <p class="bd-sub">Pick your boat brand. If we carry a boat-specific plate for it, we'll match it automatically later — no guessing on fit.</p>
        <div class="bd-field">
          <label for="brand-select">Boat brand</label>
          <select class="bd-select" id="bd-app-brand-select">
            <option value="">Select a brand…</option>
            ${(LIVE_BRANDS && LIVE_BRANDS.length ? LIVE_BRANDS : ALL_BRANDS).map(b=>`<option value="${b}">${b}</option>`).join("")}
            <option value="__other">Other / not listed</option>
          </select>
        </div>
        <div class="bd-actions">
          <button class="bd-btn" id="bd-app-boat-next" disabled>Continue</button>
        </div>
        <div class="bd-actions">
          <button class="bd-back" id="bd-app-boat-skip">Don't see your boat? Skip and use universal options →</button>
        </div>
      </div>
    `));
    const brandSelect = panel.querySelector("#bd-app-brand-select");
    const next = panel.querySelector("#bd-app-boat-next");
    function sync(){ next.disabled = !brandSelect.value; }
    brandSelect.addEventListener("change", sync);
    brandSelect.addEventListener("change", ()=>{ if(brandSelect.value) trackBuilderStart(); });
    sync();
    next.addEventListener("click", ()=>{
      const newBrand = brandSelect.value === "__other" ? "Other" : brandSelect.value;
      if(state.boatBrand && state.boatBrand !== newBrand) resetDownstreamState();
      state.boatBrand = newBrand;
      goForward("bow");
    });
    panel.querySelector("#bd-app-boat-skip").addEventListener("click", ()=>{
      trackBuilderStart();
      const newBrand = brandSelect.value && brandSelect.value !== "__other" ? brandSelect.value : "Other";
      if(state.boatBrand && state.boatBrand !== newBrand) resetDownstreamState();
      state.boatBrand = newBrand;
      goForward("bow");
    });
  }

  /* =========================================================
     RENDER: BOW STEP (multi-substep)
     ========================================================= */
  function renderBow(sub){
    sub = sub || "count";

    if(sub === "count"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 2 of 5 — Bow</p>
          <h1 class="bd-h1">How many graphs on the bow?</h1>
          <p class="bd-sub">Count graphs, chartplotters, and LiveScope displays that will be on the front of your boat.</p>
          <div class="bd-options">
            <button class="bd-opt" data-v="0">None<small>Skip straight to console</small></button>
            <button class="bd-opt" data-v="1">1 graph</button>
            <button class="bd-opt" data-v="2">2 graphs</button>
            <button class="bd-opt" data-v="3">3 graphs<small>Ultimate series only</small></button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.bow.count = b.dataset.v;
        if(b.dataset.v === "0"){ goForward("console"); }
        else if(b.dataset.v === "3"){ renderBow("plateCheck"); }
        else renderBow("screen");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>go("boat"));
      return;
    }

    if(sub === "screen"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 2 of 5 — Bow</p>
          <h1 class="bd-h1">What size are you running up front?</h1>
          <p class="bd-sub">Larger screens need a reinforced base — and Garmin 9000-series graphs without a factory gimbal need their own cradle.</p>
          <div class="bd-options bd-options--wide">
            <button class="bd-opt" data-v="small">Under 12"</button>
            <button class="bd-opt" data-v="large">12" or larger</button>
            <button class="bd-opt" data-v="commander">Big screen, no gimbal<small>Garmin 9000-series (Commander)</small></button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        if(b.dataset.v === "commander"){
          state.bow.bigScreen = true;
          renderBow("commanderHeight");
        }else{
          state.bow.bigScreen = false;
          state.bow.largeUnit = b.dataset.v === "large";
          renderBow("height");
        }
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderBow("count"));
      return;
    }

    if(sub === "commanderHeight"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 2 of 5 — Bow</p>
          <h1 class="bd-h1">What size is the graph?</h1>
          <p class="bd-sub">The Commander's cradle is sized to match your screen — 17", 19", or 22" refers to the graph itself, not mounting height.</p>
          <div class="bd-options">
            <button class="bd-opt" data-v="17">17"</button>
            <button class="bd-opt" data-v="19">19"</button>
            <button class="bd-opt" data-v="22">22"</button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.bow.commanderSize = b.dataset.v;
        renderBow("plateCheck");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderBow("screen"));
      return;
    }

    if(sub === "height"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 2 of 5 — Bow</p>
          <h1 class="bd-h1">How high do you want it off the deck?</h1>
          <p class="bd-sub">This is the biggest driver of which mount fits — our mounts range from flush with the deck up to 30".</p>
          <div class="bd-options bd-options--wide">
            <button class="bd-opt bd-opt--visual" data-v="low">
              <img src="${HEIGHT_EXAMPLE_IMAGES.low}" alt="Example low-height mount">
              <span class="bd-opt-label">Low</span>
              <small>Roughly 7"–14" — lowest profile</small>
            </button>
            <button class="bd-opt bd-opt--visual" data-v="mid">
              <img src="${HEIGHT_EXAMPLE_IMAGES.mid}" alt="Example mid-height mount">
              <span class="bd-opt-label">Mid</span>
              <small>Roughly 14"–22" — most common</small>
            </button>
            <button class="bd-opt bd-opt--visual" data-v="high">
              <img src="${HEIGHT_EXAMPLE_IMAGES.high}" alt="Example high-height mount">
              <span class="bd-opt-label">High</span>
              <small>Roughly 22"–30" — full standing view</small>
            </button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.bow.height = b.dataset.v;
        renderBow("feature");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderBow("screen"));
      return;
    }

    if(sub === "feature"){
      const needsHD = state.bow.count === "2" || state.bow.largeUnit;
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 2 of 5 — Bow</p>
          <h1 class="bd-h1">What features are you looking for?</h1>
          <div class="bd-options bd-options--wide">
            <button class="bd-opt bd-opt--visual" data-v="layFlat">
              <img src="${window.BD_FEATURE_EXAMPLES.layFlat}" alt="Example of a graph laid down">
              <span class="bd-opt-label">Laying the graph down</span>
              <small>The Flex series / BD Hybrid</small>
            </button>
            <button class="bd-opt bd-opt--visual" data-v="lowerToDeck">
              <img src="${window.BD_FEATURE_EXAMPLES.lowerToDeck}" alt="Example of a graph lowered to the deck">
              <span class="bd-opt-label">Lowering it all the way to the deck</span>
              <small>The Ultimate / Single Pole</small>
            </button>
            ${needsHD ? "" : `<button class="bd-opt bd-opt--visual" data-v="raiseLower">
              <img src="${window.BD_FEATURE_EXAMPLES.raiseLower}" alt="Example of a raise-and-lower mount">
              <span class="bd-opt-label">I just want it to raise and lower</span>
              <small>The Stic-Up</small>
            </button>`}
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.bow.feature = b.dataset.v;
        if(b.dataset.v === "layFlat") renderBow("layFlatType");
        else if(b.dataset.v === "lowerToDeck" && state.bow.height === "high") renderBow("qr");
        else renderBow("plateCheck");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderBow("height"));
      return;
    }

    if(sub === "layFlatType"){
      const isDouble = state.bow.count === "2";
      const standardLabel = state.bow.largeUnit
        ? "The Flex HD"
        : (isDouble ? "The Flex Double Stack" : "The Flex");
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 2 of 5 — Bow</p>
          <h1 class="bd-h1">Standard fold-down, or built for extra durability?</h1>
          <p class="bd-sub">The BD Hybrid combines the Ultimate's strength and durability with the Flex's pivot-and-lay-down design.</p>
          <div class="bd-options">
            <button class="bd-opt" data-v="standard">Standard<small>${standardLabel}</small></button>
            <button class="bd-opt" data-v="hybrid">Built for durability<small>BD Hybrid</small></button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.bow.layFlatType = b.dataset.v;
        renderBow("plateCheck");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderBow("feature"));
      return;
    }

    if(sub === "qr"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 2 of 5 — Bow</p>
          <h1 class="bd-h1">Pull the whole rig off when you're not fishing?</h1>
          <p class="bd-sub">The Quick Release base lets you remove the mount in seconds — handy for storage or trailering.</p>
          <div class="bd-options">
            <button class="bd-opt" data-v="yes">Yes, add Quick Release</button>
            <button class="bd-opt" data-v="no">No, standard base is fine</button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.bow.quickRelease = b.dataset.v === "yes";
        renderBow("plateCheck");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderBow("feature"));
      return;
    }

    if(sub === "plateCheck"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 2 of 5 — Bow</p>
          <h1 class="bd-h1">Checking for a ${boatLabel()} leveling plate…</h1>
          <p class="bd-sub bd-loading">Matching your boat against our current plate catalog.</p>
        </div>
      `));
      resolveLevelingPlate();
      return;
    }
  }

  // Merge a static bundled list with a live products.json result, deduping by handle.
  function mergeWithLive(staticMatches, liveProducts, titleStrip){
    const merged = staticMatches.slice();
    const known = new Set(merged.map(m=>m.handle));
    (liveProducts||[]).forEach(p=>{
      if(!known.has(p.handle)){
        merged.push({
          brand: state.boatBrand,
          label: p.title.replace(titleStrip, ""),
          handle: p.handle,
          price: p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null
        });
        known.add(p.handle);
      }
    });
    return merged;
  }

  async function resolveLevelingPlate(){
    const brand = state.boatBrand;
    let matches = LEVELING_PLATES.filter(p => p.brand === brand);
    const live = await findBoatMatches("leveling-plates", brand); // null if fetch unavailable
    if(live) matches = mergeWithLive(matches, live, /^Leveling Plate\s*-?\s*/i);

    if(matches.length === 0){
      state.bow.plateStatus = "manual";
      renderBowFallback();
    }else{
      renderBowModelPicker(matches);
    }
  }

  function renderBowModelPicker(matches){
    panel.innerHTML = "";
    panel.appendChild(el(`
      <div>
        <p class="bd-eyebrow">Step 2 of 5 — Bow</p>
        <h1 class="bd-h1">${matches.length > 1 ? "We carry more than one leveling plate for this brand — pick the closest match." : "We carry one leveling plate for this brand — confirm it's the right fit."}</h1>
        <p class="bd-sub">Which ${state.boatBrand} matches your boat?</p>
        <div class="bd-reference">
          <img src="${LEVELING_PLATE_REFERENCE_IMAGE}" alt="Example leveling plate">
          <p>Not sure what a leveling plate is? This is one — it bolts flush to your deck to create a level base for the bow mount. Example shown; yours will be shaped for your boat.</p>
        </div>
        <div class="bd-model-list" id="bd-app-model-list"></div>
        <div class="bd-actions"><button class="bd-back" id="bd-app-skip">None of these match →</button></div>
      </div>
    `));
    const list = panel.querySelector("#bd-app-model-list");
    matches.forEach(m=>{
      const btn = document.createElement("button");
      btn.textContent = `${m.label}${m.price!=null ? " — $"+m.price.toFixed(2) : ""}`;
      btn.addEventListener("click", ()=>{
        state.bow.plateProduct = m;
        state.bow.plateStatus = "matched";
        goForward("console");
      });
      list.appendChild(btn);
    });
    panel.querySelector("#bd-app-skip").addEventListener("click", ()=>{
      state.bow.plateStatus = "manual";
      renderBowFallback();
    });
  }

  function renderBowFallback(){
    panel.innerHTML = "";
    panel.appendChild(el(`
      <div>
        <p class="bd-eyebrow">Step 2 of 5 — Bow</p>
        <h1 class="bd-h1">No dedicated plate for that boat yet</h1>
        <p class="bd-sub">No problem — where do you want the mount positioned?</p>
        <div class="bd-options bd-options--wide">
          <button class="bd-opt" data-v="pedal">In front of the trolling motor<small>Bridge spans over the pedal so it doesn't block your foot</small></button>
          <button class="bd-opt" data-v="side">Off to the side<small>Mounting Plate, clear of the pedal</small></button>
        </div>
        <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
      </div>
    `));
    panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
      state.bow.manualPosition = b.dataset.v;
      goForward("console");
    }));
    panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderBow("plateCheck"));
  }

  /* =========================================================
     RENDER: CONSOLE STEP
     ========================================================= */
  function renderConsole(sub){
    sub = sub || "count";

    if(sub === "count"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 3 of 5 — Console</p>
          <h1 class="bd-h1">Any graphs at the console?</h1>
          <div class="bd-options">
            <button class="bd-opt" data-v="0">None<small>Skip to LiveScope</small></button>
            <button class="bd-opt" data-v="1">1 graph</button>
            <button class="bd-opt" data-v="2">2 graphs</button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.console.count = b.dataset.v;
        if(b.dataset.v === "0") goForward("livescope");
        else renderConsole("surface");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>go("bow"));
      return;
    }

    if(sub === "surface"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 3 of 5 — Console</p>
          <h1 class="bd-h1">Flat console, or does it have a shelf?</h1>
          <p class="bd-sub">This decides which universal mount pairs with your plate.</p>
          <div class="bd-options bd-options--wide">
            <button class="bd-opt bd-opt--visual" data-v="flat">
              <img src="${window.BD_CONSOLE_EXAMPLES.flat}" alt="Example flat console">
              <span class="bd-opt-label">Flat console</span>
              <small>Ultimate Console Mount</small>
            </button>
            <button class="bd-opt bd-opt--visual" data-v="shelf">
              <img src="${window.BD_CONSOLE_EXAMPLES.shelf}" alt="Example console with a shelf">
              <span class="bd-opt-label">Console with a shelf</span>
              <small>LocDown Pivot and Slide</small>
            </button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.console.surface = b.dataset.v;
        if(b.dataset.v === "shelf"){
          // Shelf consoles use the LocDown as-is — no plate matching needed.
          state.console.plateStatus = null;
          state.console.plateProduct = null;
          goForward("livescope");
        }else{
          renderConsole("plateCheck");
        }
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderConsole("count"));
      return;
    }

    if(sub === "plateCheck"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 3 of 5 — Console</p>
          <h1 class="bd-h1">Checking for a ${boatLabel()} console plate…</h1>
          <p class="bd-sub bd-loading">Matching your boat against our current console plate catalog.</p>
        </div>
      `));
      resolveConsolePlate();
      return;
    }
  }

  async function resolveConsolePlate(){
    const brand = state.boatBrand;
    let matches = CONSOLE_PLATES.filter(p => p.brand === brand);
    const live = await findBoatMatches("console-plates", brand);
    if(live) matches = mergeWithLive(matches, live, /^Console Plate\s*-?\s*/i);

    if(matches.length === 0){
      renderConsoleFallback();
    }else{
      renderConsoleModelPicker(matches);
    }
  }

  function renderConsoleModelPicker(matches){
    panel.innerHTML = "";
    panel.appendChild(el(`
      <div>
        <p class="bd-eyebrow">Step 3 of 5 — Console</p>
        <h1 class="bd-h1">Which ${state.boatBrand} console matches?</h1>
        <p class="bd-sub">${matches.length > 1 ? "Pick the closest match." : "We carry one console plate for this brand — confirm it's the right fit."}</p>
        <div class="bd-model-list" id="bd-app-model-list"></div>
        <div class="bd-actions"><button class="bd-back" id="bd-app-skip">None of these match →</button></div>
      </div>
    `));
    const list = panel.querySelector("#bd-app-model-list");
    matches.forEach(m=>{
      const btn = document.createElement("button");
      btn.textContent = `${m.label}${m.price!=null ? " — $"+m.price.toFixed(2) : ""}`;
      btn.addEventListener("click", ()=>{
        state.console.plateProduct = m;
        state.console.plateStatus = "matched";
        goForward("livescope");
      });
      list.appendChild(btn);
    });
    panel.querySelector("#bd-app-skip").addEventListener("click", renderConsoleFallback);
  }

  function renderConsoleFallback(){
    panel.innerHTML = "";
    panel.appendChild(el(`
      <div>
        <p class="bd-eyebrow">Step 3 of 5 — Console</p>
        <h1 class="bd-h1">Does your console need a backing plate?</h1>
        <p class="bd-sub">Does your console already come from the factory equipped to handle electronics, or does it need one custom to your dash size?</p>
        <div class="bd-options bd-options--wide">
          <button class="bd-opt" data-v="equipped">Already equipped<small>Skip straight to the mount</small></button>
          <button class="bd-opt" data-v="universal">Needs a plate<small>Choose a universal size</small></button>
        </div>
        <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
      </div>
    `));
    panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
      if(b.dataset.v === "equipped"){
        state.console.plateStatus = "equipped";
        goForward("livescope");
      }else{
        renderConsoleUniversalSize();
      }
    }));
    panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderConsole("surface"));
  }

  function renderConsoleUniversalSize(){
    panel.innerHTML = "";
    panel.appendChild(el(`
      <div>
        <p class="bd-eyebrow">Step 3 of 5 — Console</p>
        <h1 class="bd-h1">Which size fits your dash cutout?</h1>
        <p class="bd-sub">Measure the opening before ordering — these are sold by exact size.</p>
        <div class="bd-model-list" id="bd-app-model-list"></div>
        <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
      </div>
    `));
    const list = panel.querySelector("#bd-app-model-list");
    UNIVERSAL_CONSOLE_PLATES.forEach(m=>{
      const btn = document.createElement("button");
      btn.textContent = `${m.label} — $${m.price.toFixed(2)}`;
      btn.addEventListener("click", ()=>{
        state.console.plateProduct = m;
        state.console.plateStatus = "universal";
        goForward("livescope");
      });
      list.appendChild(btn);
    });
    panel.querySelector("#bd-app-back").addEventListener("click", renderConsoleFallback);
  }

  /* =========================================================
     RENDER: LIVESCOPE STEP
     ========================================================= */
  function renderLiveScope(sub){
    sub = sub || "uses";

    if(sub === "uses"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 4 of 5 — LiveScope</p>
          <h1 class="bd-h1">Running LiveScope or another forward-facing sonar?</h1>
          <div class="bd-options">
            <button class="bd-opt" data-v="yes">Yes</button>
            <button class="bd-opt" data-v="no">No</button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.liveScope.uses = b.dataset.v === "yes";
        if(state.liveScope.uses) renderLiveScope("location");
        else goForward("results");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>go("console"));
      return;
    }

    if(sub === "location"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 4 of 5 — LiveScope</p>
          <h1 class="bd-h1">On the trolling motor, or a separate pole?</h1>
          <div class="bd-options">
            <button class="bd-opt" data-v="trolling">Trolling motor shaft</button>
            <button class="bd-opt" data-v="pole">Separate pole</button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.liveScope.location = b.dataset.v;
        if(b.dataset.v === "trolling") renderLiveScope("tmBrand");
        else renderLiveScope("poleStyle");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderLiveScope("uses"));
      return;
    }

    if(sub === "poleStyle"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 4 of 5 — LiveScope</p>
          <h1 class="bd-h1">Breakaway, or fixed?</h1>
          <p class="bd-sub">Breakaway releases on impact with cover or structure, then resets — fixed is simpler and costs less.</p>
          <div class="bd-options">
            <button class="bd-opt" data-v="breakaway">Breakaway</button>
            <button class="bd-opt" data-v="fixed">Fixed</button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.liveScope.poleStyle = b.dataset.v;
        if(b.dataset.v === "breakaway") renderLiveScope("poleDualMode");
        else renderLiveScope("poleMount");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderLiveScope("location"));
      return;
    }

    if(sub === "poleDualMode"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 4 of 5 — LiveScope</p>
          <h1 class="bd-h1">Want to be able to run it fixed too?</h1>
          <p class="bd-sub">The Breakaway 2.0 locks into a fixed position or releases on impact — the Breakaway Jr. is breakaway-only.</p>
          <div class="bd-options">
            <button class="bd-opt" data-v="yes">Yes, want both modes</button>
            <button class="bd-opt" data-v="no">No, breakaway-only is fine</button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.liveScope.poleDualMode = b.dataset.v === "yes";
        renderLiveScope("poleMount");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderLiveScope("poleStyle"));
      return;
    }

    if(sub === "poleMount"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 4 of 5 — LiveScope</p>
          <h1 class="bd-h1">How will you be mounting this pole?</h1>
          <p class="bd-sub">Track and gunnel mounting are only available on the Breakaway 2.0 line — the Jr. and Fixed poles are direct-mount only.</p>
          <div class="bd-options bd-options--wide">
            <button class="bd-opt" data-v="direct">Direct to the boat</button>
            <button class="bd-opt" data-v="track">Universal 3" accessory track</button>
            <button class="bd-opt" data-v="gunnel">Integrated gunnel track<small>Lund, Alumacraft, Versa Track</small></button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.liveScope.poleMount = b.dataset.v;
        if(b.dataset.v === "direct"){
          if(state.liveScope.poleStyle === "fixed") state.liveScope.poleProduct = PRODUCTS.transducerFixedStandard;
          else state.liveScope.poleProduct = state.liveScope.poleDualMode ? PRODUCTS.transducerBreakawayStandard : PRODUCTS.transducerBreakawayJr;
          goForward("results");
        }else if(b.dataset.v === "track"){
          state.liveScope.poleProduct = PRODUCTS.transducerTrackBreakaway;
          goForward("results");
        }else{
          renderLiveScope("poleGunnelBrand");
        }
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>{
        renderLiveScope(state.liveScope.poleStyle === "breakaway" ? "poleDualMode" : "poleStyle");
      });
      return;
    }

    if(sub === "poleGunnelBrand"){
      const options = gunnelOptionsForBrand();

      // Not a Lund or Alumacraft — we don't carry a gunnel-track fitment for
      // this brand, so offer a clear way back to the other mounting methods
      // instead of pushing an ill-fitting product.
      if(options.length === 0){
        panel.innerHTML = "";
        panel.appendChild(el(`
          <div>
            <p class="bd-eyebrow">Step 4 of 5 — LiveScope</p>
            <h1 class="bd-h1">We don't carry a gunnel track for that boat</h1>
            <p class="bd-sub">Integrated gunnel-track poles are only available for Lund and Alumacraft right now. Pick a different mounting method instead.</p>
            <div class="bd-actions">
              <button class="bd-btn" id="skip-gunnel">Choose a different mounting method →</button>
            </div>
            <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
          </div>
        `));
        panel.querySelector("#skip-gunnel").addEventListener("click", ()=>renderLiveScope("poleMount"));
        panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderLiveScope("poleMount"));
        return;
      }

      // Only one real option for this brand (e.g. Alumacraft, which only comes
      // in one size) — resolve it directly instead of asking a one-answer question.
      if(options.length === 1){
        const key = options[0];
        const v = SPORT_TRACK_VARIANTS[key];
        state.liveScope.poleGunnelSystem = key;
        state.liveScope.poleProduct = withVariant(PRODUCTS.transducerSportTrack, {
          name: `${PRODUCTS.transducerSportTrack.name} (${key})`,
          price: v.price, variantId: v.variantId,
          why: PRODUCTS.transducerSportTrack.why + ` Set for ${key}.`
        });
        goForward("results");
        return;
      }

      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 4 of 5 — LiveScope</p>
          <h1 class="bd-h1">Which ${state.boatBrand} gunnel track?</h1>
          <p class="bd-sub">4x8 arm shown — a 4x4 option is also available on the product page if that's what you need.</p>
          <div class="bd-options">
            ${options.map(key=>`<button class="bd-opt" data-v="${key}">${key.split(" / ")[0].replace(state.boatBrand, "").trim()}</button>`).join("")}
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        const key = b.dataset.v;
        const v = SPORT_TRACK_VARIANTS[key];
        state.liveScope.poleGunnelSystem = key;
        state.liveScope.poleProduct = withVariant(PRODUCTS.transducerSportTrack, {
          name: `${PRODUCTS.transducerSportTrack.name} (${key})`,
          price: v.price, variantId: v.variantId,
          why: PRODUCTS.transducerSportTrack.why + ` Set for ${key}.`
        });
        goForward("results");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderLiveScope("poleMount"));
      return;
    }

    if(sub === "tmBrand"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 4 of 5 — LiveScope</p>
          <h1 class="bd-h1">What trolling motor is it mounting to?</h1>
          <p class="bd-sub">The Garmin Kraken needs a different mount than everything else.</p>
          <div class="bd-options">
            ${TROLLING_MOTOR_BRANDS.map(b=>`<button class="bd-opt" data-v="${b}">${b}</button>`).join("")}
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.liveScope.tmBrand = b.dataset.v;
        if(b.dataset.v === "Garmin") renderLiveScope("tmModel");
        else goForward("results");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderLiveScope("location"));
      return;
    }

    if(sub === "tmModel"){
      panel.innerHTML = "";
      panel.appendChild(el(`
        <div>
          <p class="bd-eyebrow">Step 4 of 5 — LiveScope</p>
          <h1 class="bd-h1">Force or Kraken?</h1>
          <div class="bd-options">
            <button class="bd-opt" data-v="Force">Garmin Force</button>
            <button class="bd-opt" data-v="Kraken">Garmin Kraken</button>
          </div>
          <div class="bd-actions"><button class="bd-back" id="bd-app-back">← Back</button></div>
        </div>
      `));
      panel.querySelectorAll(".bd-opt").forEach(b=>b.addEventListener("click", ()=>{
        state.liveScope.tmModel = b.dataset.v;
        goForward("results");
      }));
      panel.querySelector("#bd-app-back").addEventListener("click", ()=>renderLiveScope("tmBrand"));
      return;
    }
  }

  /* =========================================================
     DECISION LOGIC
     ========================================================= */
  function resolveCommander(){
    const count = state.bow.count === "2" ? "2" : "1";
    const size = state.bow.commanderSize || "17";
    let key = `${count}-${size}`;
    let note = "";
    if(!COMMANDER_VARIANTS[key]){
      key = count === "2" ? "2-17" : `1-${size}`;
      note = " Double only comes in the 17\" cradle size — switched to match.";
    }
    const v = COMMANDER_VARIANTS[key];
    return withVariant(PRODUCTS.commander, {
      name: `BD Commander Single Pole Mount (${count === "2" ? "Double" : "Single"} / ${key.split("-")[1]}" graph)`,
      price: v.price, variantId: v.variantId,
      why: PRODUCTS.commander.why + note
    });
  }

  function pickBowMount(){
    const b = state.bow;
    if(b.count === "0" || b.count === null) return { primary:null, upgrades:[] };
    if(b.count === "3") return { primary: PRODUCTS.ultimateTriple, upgrades:[] };
    if(b.bigScreen) return { primary: resolveCommander(), upgrades:[] };

    const isDouble = b.count === "2";
    // Graph size (largeUnit) drives the Flex/Flex HD tier below — graph
    // count (isDouble) only picks which stack variant of that tier to use.
    // The Ultimate/Single Pole ladder further down is likewise driven by
    // height, with count only picking the stack variant there too.
    const ultimateVariant = (withQR) => withQR
      ? (isDouble ? PRODUCTS.ultimateDoubleQR : PRODUCTS.ultimateQR)
      : (isDouble ? PRODUCTS.ultimateDouble : PRODUCTS.ultimate);
    const ultimateShortyVariant = (withQR) => withQR
      ? (isDouble ? PRODUCTS.ultimateShortyDoubleQR : PRODUCTS.ultimateShortyQR)
      : (isDouble ? PRODUCTS.ultimateShortyDouble : PRODUCTS.ultimateShorty);

    // "I just want it to raise and lower" (Stic-Up) has no equivalent for
    // 2+ graphs or a large graph — the UI hides this option whenever needsHD
    // is true, so this only ever resolves for a single graph 12" or under.
    if(b.feature === "raiseLower"){
      return { primary: PRODUCTS.sticUp, upgrades: [PRODUCTS.singlePoleShort] };
    }

    if(b.feature === "layFlat"){
      // The Ultimate is always reachable as an upgrade from any fold-down
      // pick, on top of whichever fold-down-specific step-up applies.
      const ultimateUpgrade = ultimateVariant(false);
      if(b.layFlatType === "hybrid"){
        return { primary: isDouble ? PRODUCTS.bdHybridDouble : PRODUCTS.bdHybrid, upgrades: [ultimateUpgrade] };
      }
      // Graph size (not count) decides Flex vs. Flex HD here — a large
      // graph needs the reinforced HD base regardless of count, while two
      // graphs under 12" together are still within plain Flex's rating.
      const shorty = b.height !== "high";
      const flexHDVariant = shorty
        ? (isDouble ? PRODUCTS.flexHDShortyDouble : PRODUCTS.flexHDShorty)
        : (isDouble ? PRODUCTS.flexHDDouble : PRODUCTS.flexHD);
      const hybridVariant = isDouble ? PRODUCTS.bdHybridDouble : PRODUCTS.bdHybrid;

      if(b.largeUnit){
        return { primary: flexHDVariant, upgrades: [hybridVariant, ultimateUpgrade] };
      }

      // Under 12" — plain Flex covers this whether it's one graph or two
      // together. No lower-profile "Shorty" double-stack exists, so a
      // double pick always uses the standard Flex Double Stack.
      const primary = isDouble ? PRODUCTS.flexDoubleStack : (shorty ? PRODUCTS.flexShorty : PRODUCTS.flex);
      return { primary, upgrades: [flexHDVariant, hybridVariant, ultimateUpgrade] };
    }

    // "lowerToDeck" (or not yet answered). Height picks the tier — Single
    // Pole / Ultimate Shorty / full Ultimate — the same ladder regardless of
    // graph count. Graph count (isDouble) only picks which stack variant of
    // that tier to use; Single Pole has a real double-stack version.
    const singlePoleVariant = (tall) => {
      if(tall) return isDouble ? PRODUCTS.singlePoleTallDouble : PRODUCTS.singlePoleTall;
      return isDouble ? PRODUCTS.singlePoleShortDouble : PRODUCTS.singlePoleShort;
    };
    if(b.height === "low"){
      return { primary: singlePoleVariant(false), upgrades: [singlePoleVariant(true)] };
    }
    if(b.height === "mid"){
      return { primary: ultimateShortyVariant(false), upgrades: [ultimateVariant(false)] };
    }
    // high
    const primary = ultimateVariant(!!b.quickRelease);
    return { primary, upgrades: b.quickRelease ? [] : [ultimateVariant(true)] };
  }

  function pickConsoleMount(){
    if(state.console.count === "0" || state.console.count === null) return [];
    if(state.console.surface === "shelf") return [state.console.count === "2" ? PRODUCTS.locDownPair : PRODUCTS.locDown];
    return [state.console.count === "2" ? PRODUCTS.ultimateConsoleDual : PRODUCTS.ultimateConsoleSingle];
  }

  // Pole "upgrade" paths — the compact/budget poles that have a more capable
  // sibling worth surfacing (mirrors the Breakaway Jr. → Breakaway 2.0 case).
  function poleUpgradeFor(product){
    if(product === PRODUCTS.transducerBreakawayJr) return PRODUCTS.transducerBreakawayStandard;
    if(product === PRODUCTS.transducerFixedStandard) return PRODUCTS.transducerBreakawayStandard;
    return null;
  }

  function pickLiveScopeMount(){
    const ls = state.liveScope;
    if(!ls.uses) return { primary:null, secondary:null, upgrade:null };
    if(ls.location === "pole"){
      if(!ls.poleProduct) return { primary:null, secondary:null, upgrade:null };
      return { primary: ls.poleProduct, secondary: PRODUCTS.zeroedIn, upgrade: poleUpgradeFor(ls.poleProduct) };
    }
    if(ls.tmBrand === "Garmin" && ls.tmModel === "Kraken") return { primary: PRODUCTS.zeroKraken, secondary:null, upgrade:null };
    return { primary: PRODUCTS.zeroedIn, secondary:null, upgrade:null };
  }

  /* =========================================================
     RENDER: RESULTS
     ========================================================= */
  function normalizeProduct(p, whyOverride){
    // Normalizes both PRODUCTS entries and boat-plate matches into one shape.
    if(p.name) return whyOverride ? Object.assign({}, p, {why: whyOverride}) : p;
    return {
      name: (p.brand ? p.brand + " — " : "") + (p.label || "Plate"),
      handle: p.handle, price: p.price, variantId: p.variantId, image: p.image, variants: p.variants,
      why: whyOverride || ""
    };
  }

  function buildLineItems(bowMount, consoleMounts, lsMount){
    const items = [];
    const upgrades = []; // {radioGroup, product, baselineName, forGroup}

    if(bowMount.primary){
      const bowUpgrades = bowMount.upgrades || [];
      const radioGroup = bowUpgrades.length ? "bow-mount" : null;
      items.push({ id:"bow-0", group:"Bow Mount", tag:"Recommended",
        product:bowMount.primary, selectable:!!bowMount.primary.variantId, selectedByDefault:true, radioGroup });
      bowUpgrades.forEach(u=>{
        upgrades.push({ radioGroup, product:u, baselineName:bowMount.primary.name, forGroup:"Bow Mount" });
      });
      if(state.bow.plateStatus === "matched" && state.bow.plateProduct){
        const p = state.bow.plateProduct;
        items.push({ id:"bow-plate", group:"Bow Mount", tag:"Boat-specific leveling plate",
          product: normalizeProduct(p, `Matched to ${state.boatBrand}.`),
          selectable: !!p.variantId, selectedByDefault:true });
      }else if(state.bow.plateStatus === "manual"){
        const fallback = state.bow.manualPosition === "pedal" ? PRODUCTS.bridge : PRODUCTS.mountingPlate;
        items.push({ id:"bow-plate", group:"Bow Mount", tag:"No boat-specific plate — fallback",
          product: fallback, selectable:!!fallback.variantId, selectedByDefault:true });
      }
    }

    if(consoleMounts.length){
      consoleMounts.forEach((p,i)=>{
        items.push({ id:`console-${i}`, group:"Console Mount", tag:"Recommended", product:p, selectable:!!p.variantId, selectedByDefault:true });
      });
      if(state.console.plateStatus === "matched" && state.console.plateProduct){
        const p = state.console.plateProduct;
        items.push({ id:"console-plate", group:"Console Mount", tag:"Boat-specific console plate",
          product: normalizeProduct(p, `Matched to ${state.boatBrand}.`),
          selectable: !!p.variantId, selectedByDefault:true });
      }else if(state.console.plateStatus === "universal" && state.console.plateProduct){
        const p = state.console.plateProduct;
        items.push({ id:"console-plate", group:"Console Mount", tag:"Universal sized plate",
          product: normalizeProduct(p, "No boat-specific plate — confirm this size against your dash cutout before ordering."),
          selectable: !!p.variantId, selectedByDefault:true });
      }
    }

    if(lsMount.primary){
      const radioGroup = lsMount.upgrade ? "ls-mount" : null;
      items.push({ id:"ls-0", group:"LiveScope", tag:"Recommended", product:lsMount.primary,
        selectable:!!lsMount.primary.variantId, selectedByDefault:true, radioGroup });
      if(lsMount.upgrade){
        upgrades.push({ radioGroup, product:lsMount.upgrade, baselineName:lsMount.primary.name, forGroup:"LiveScope" });
      }
      if(lsMount.secondary){
        items.push({ id:"ls-1", group:"LiveScope", tag:"Zero-degree clamp for the pole tip", product:lsMount.secondary, selectable:!!lsMount.secondary.variantId, selectedByDefault:true });
      }
    }

    const showHardware = !!bowMount.primary || consoleMounts.length;
    const showPointer = state.liveScope.location === "pole";
    if(showHardware) items.push({ id:"acc-hardware", group:"Accessories", tag:"Mounts ship without hardware", product:PRODUCTS.hardware, selectable:true, selectedByDefault:true });
    if(showPointer) items.push({ id:"acc-pointer", group:"Accessories", tag:"Optional — aim reference", product:PRODUCTS.polePointer, selectable:true, selectedByDefault:false });
    items.push({ id:"acc-knobs", group:"Accessories", tag:"Optional", product:PRODUCTS.graphKnobs, selectable:true, selectedByDefault:false });
    items.push({ id:"acc-cable", group:"Accessories", tag:"Optional", product:PRODUCTS.cableSleeve, selectable:true, selectedByDefault:false });
    items.push({ id:"acc-transom", group:"Accessories", tag:"Optional", product:PRODUCTS.transomSaver, selectable:true, selectedByDefault:false });
    items.push({ id:"acc-clips", group:"Accessories", tag:"Optional", product:PRODUCTS.steeringClips, selectable:true, selectedByDefault:false });

    // Upgraded Options — each is radio-linked to its baseline item above, so
    // picking the upgrade swaps it in rather than adding both to cart.
    upgrades.forEach((u,i)=>{
      items.push({ id:`upgrade-${i}`, group:"Upgraded Options", tag:`Upgrade from ${u.baselineName}`,
        product:u.product, selectable:!!u.product.variantId, selectedByDefault:false, radioGroup:u.radioGroup });
    });

    return items;
  }

  function cardHTML(item){
    const p = item.product;
    const img = p.image ? `<img src="${p.image}" alt="${p.name}" loading="lazy">` : `<div class="bd-card-img-placeholder">Image loading…</div>`;
    const inputType = item.radioGroup ? "radio" : "checkbox";
    const inputName = item.radioGroup || item.id;
    const checkedAttr = item.selectable && item.selectedByDefault ? "checked" : "";
    const checkInput = item.selectable
      ? `<input type="${inputType}" name="${inputName}" class="bd-card-check" data-item-id="${item.id}" data-radio-group="${item.radioGroup||""}" ${checkedAttr}>`
      : "";
    const unavailableNote = item.selectable ? "" : `<div class="bd-card-unavailable">Live cart data still loading for your matched boat part — not counted in the total yet. Use "View product" to add it now, or check back in a moment.</div>`;
    const variantPicker = (p.variants && p.variants.length > 1) ? `
      <label class="bd-variant-label" onclick="event.stopPropagation()">
        Option
        <select class="bd-variant-select" data-item-id="${item.id}">
          ${p.variants.map(v => `<option value="${v.id}" data-price="${v.price}" ${v.id===p.variantId?"selected":""}>${v.title}</option>`).join("")}
        </select>
      </label>` : "";
    return `
      <label class="bd-card bd-card--selectable ${item.selectable ? "" : "bd-card--disabled"}" data-item-id="${item.id}">
        ${checkInput}
        <div class="bd-card-img">${img}</div>
        <div class="bd-card-body">
          <div class="bd-card-tag">${item.tag}</div>
          <div class="bd-card-name">${p.name}</div>
          ${variantPicker}
          <div class="bd-card-why">${p.why || ""}</div>
          <div class="bd-card-price" data-item-id="${item.id}">${priceLabel(p)}</div>
          ${unavailableNote}
          ${p.handle ? `<a class="${item.selectable ? "bd-card-link" : "bd-card-cta"}" href="${productUrl(p)}" target="_blank" rel="noopener" onclick="event.stopPropagation()">${item.selectable ? "View product ↗" : "Add on Product Page"}</a>` : ""}
        </div>
      </label>`;
  }

  async function renderResults(){
    panel.innerHTML = "";
    panel.appendChild(el(`
      <div>
        <p class="bd-eyebrow">Step 5 of 5</p>
        <h1 class="bd-h1">Building your sheet…</h1>
        <p class="bd-sub bd-loading">Pulling live pricing and images for your matched parts.</p>
      </div>
    `));

    const bowMount = pickBowMount();
    const consoleMounts = pickConsoleMount();
    const lsMount = pickLiveScopeMount();

    let items = buildLineItems(bowMount, consoleMounts, lsMount);
    // Live-resolve every item's product (core mounts and boat plates alike) in
    // parallel — one refresh mechanism for the whole catalog instead of a
    // special case just for plates. Each item keeps its selectable/tag/group
    // metadata; only the underlying product data (price/image/variant) refreshes.
    const resolvedProducts = await Promise.all(items.map(it => resolveProductLive(it.product)));
    items = items.map((it, i) => Object.assign({}, it, {
      product: resolvedProducts[i],
      selectable: !!resolvedProducts[i].variantId
    }));

    const selection = {};
    items.forEach(it => { selection[it.id] = !!(it.selectable && it.selectedByDefault); });

    const groups = ["Bow Mount", "Console Mount", "LiveScope", "Upgraded Options", "Accessories"];
    const groupsHTML = groups.map(g=>{
      const groupItems = items.filter(it=>it.group===g);
      if(!groupItems.length) return "";
      return `<div class="bd-card-group"><h3>${g}</h3><div class="bd-cards">${groupItems.map(cardHTML).join("")}</div></div>`;
    }).join("");

    const nothingSelected = !bowMount.primary && !consoleMounts.length && !lsMount.primary;

    panel.innerHTML = "";
    panel.appendChild(el(`
      <div>
        <p class="bd-eyebrow">Step 5 of 5</p>
        <h1 class="bd-h1">Your build sheet</h1>
        <p class="bd-sub">${state.boatBrand === "Other" ? "Universal parts" : state.boatBrand} — pick what you want, then add it all to cart in one go.</p>
        ${nothingSelected ? `<p class="bd-note">No electronics were selected for the bow, console, or LiveScope — go back and add at least one to get mount recommendations, or just grab accessories below.</p>` : ""}
        ${groupsHTML}
        ${items.length ? `
        <div class="bd-cart-bar" id="bd-app-cart-bar">
          <div>
            <span class="bd-cart-count" id="bd-app-cart-count">0 items selected</span>
            <span class="bd-cart-amount" id="bd-app-cart-amount">$0.00</span>
          </div>
          <button class="bd-btn" id="bd-app-add-to-cart-btn">Add to Cart</button>
        </div>
        <div id="bd-app-cart-result"></div>
        ` : ""}
        <div class="bd-summary-actions">
          <button class="bd-btn bd-btn--ghost bd-restart" id="bd-app-restart">Start Over</button>
        </div>
      </div>
    `));

    function updateBar(){
      let total = 0, count = 0;
      items.forEach(it=>{
        if(selection[it.id]){
          count++;
          if(it.product.price != null) total += it.product.price;
        }
      });
      const countEl = document.getElementById("bd-app-cart-count");
      const amountEl = document.getElementById("bd-app-cart-amount");
      const btn = document.getElementById("bd-app-add-to-cart-btn");
      if(countEl) countEl.textContent = `${count} item${count===1?"":"s"} selected`;
      if(amountEl) amountEl.textContent = `$${total.toFixed(2)}`;
      if(btn) btn.disabled = count === 0;
    }

    panel.querySelectorAll(".bd-card-check").forEach(input=>{
      input.addEventListener("change", ()=>{
        const id = input.dataset.itemId;
        const radioGroup = input.dataset.radioGroup;
        if(radioGroup){
          items.filter(it=>it.radioGroup===radioGroup).forEach(it=>{ selection[it.id] = (it.id === id); });
          panel.querySelectorAll(`[data-radio-group="${radioGroup}"]`).forEach(el=>{
            el.closest(".bd-card").classList.toggle("is-checked", el.dataset.itemId === id);
          });
        }else{
          selection[id] = input.checked;
          input.closest(".bd-card").classList.toggle("is-checked", input.checked);
        }
        updateBar();
      });
      // set initial visual state for pre-checked cards
      if(input.checked) input.closest(".bd-card").classList.add("is-checked");
    });

    panel.querySelectorAll(".bd-variant-select").forEach(select=>{
      select.addEventListener("change", ()=>{
        const id = select.dataset.itemId;
        const item = items.find(it=>it.id===id);
        if(!item) return;
        const opt = select.options[select.selectedIndex];
        item.product.variantId = opt.value;
        item.product.price = parseFloat(opt.dataset.price);
        const priceEl = panel.querySelector(`.bd-card-price[data-item-id="${id}"]`);
        if(priceEl) priceEl.textContent = priceLabel(item.product);
        updateBar();
      });
    });

    updateBar();

    // Only if the customer is still on the build sheet once live pricing
    // resolves — not if they navigated away while it was loading.
    if(state.step === "results") trackBuilderComplete(items, selection);

    // One add action per build sheet: its ID is reused across retries so an
    // add that reached Shopify without a confirmed response is never re-sent.
    const cartAction = { buildId: newBuildId(), busy: false, done: false, uncertain: false };
    const addBtn = document.getElementById("bd-app-add-to-cart-btn");
    if(addBtn) addBtn.addEventListener("click", ()=> addSelectedToCart(items, selection, cartAction));

    panel.querySelector("#bd-app-restart").addEventListener("click", ()=>{
      location.reload();
    });
  }

  /* =========================================================
     CART
     Uses the storefront's own Ajax cart on the current origin (and locale
     prefix), so the request and the shopper's cart cookie always match the
     page — including theme previews. Every add carries the builder's private
     attribution properties; there is deliberately no permalink fallback,
     since a permalink can't carry line item properties. When an add's
     outcome is unclear (network error, timeout, unexpected status), the live
     cart is checked for this build's ID before anything is sent again.
     ========================================================= */
  const CART_TIMEOUT_MS = 15000;

  function cartUrl(path){
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return (root.endsWith("/") ? root : root + "/") + path;
  }

  async function fetchWithTimeout(url, opts){
    const ctrl = typeof AbortController === "function" ? new AbortController() : null;
    const timer = ctrl ? setTimeout(() => ctrl.abort(), CART_TIMEOUT_MS) : null;
    try{
      return await fetch(url, Object.assign({}, opts, ctrl ? { signal: ctrl.signal } : {}));
    }finally{
      if(timer) clearTimeout(timer);
    }
  }

  // Lines in the live cart that came from this build's add, or null if the
  // cart itself couldn't be read.
  async function findBuilderLines(buildId){
    try{
      const res = await fetchWithTimeout(cartUrl("cart.js"), { headers: {"Accept": "application/json"}, cache: "no-store" });
      if(!res.ok) return null;
      const cart = await res.json();
      return (cart.items || []).filter(l => l.properties && l.properties._boat_builder_id === buildId);
    }catch(e){
      return null;
    }
  }

  function setCartButton(label, disabled){
    const btn = document.getElementById("bd-app-add-to-cart-btn");
    if(btn){ btn.textContent = label; btn.disabled = disabled; }
  }

  function showCartMessage(html){
    const resultEl = document.getElementById("bd-app-cart-result");
    if(resultEl) resultEl.innerHTML = html ? `<div class="bd-cart-success">${html}</div>` : "";
  }

  function viewCartLink(){
    return `<a class="bd-card-cta" href="${cartUrl("cart")}" style="display:inline-block; width:auto; padding:12px 28px;">View Cart</a>`;
  }

  // Shopify confirmed these lines exist in the cart — the add is done. Hides
  // the bar, shows the result, and fires the analytics event exactly once.
  function confirmCartAdd(action, selectedItems, lines){
    if(action.done) return;
    action.done = true;
    action.uncertain = false;
    const addedVariantIds = new Set(lines.map(l => String(l.variant_id)));
    const addedItems = selectedItems.filter(it => addedVariantIds.has(String(it.product.variantId)));
    const missing = selectedItems.length - addedItems.length;
    showCartResult(lines.reduce((n, l) => n + l.quantity, 0), missing);
    trackBuilderAddToCart(addedItems, lines);
  }

  async function addSelectedToCart(items, selection, action){
    // Synchronous guard — rapid repeat clicks land here before any await.
    if(action.busy || action.done) return;
    const selectedItems = items.filter(it => selection[it.id] && it.product.variantId);
    if(!selectedItems.length) return;
    action.busy = true;
    setCartButton("Adding…", true);
    showCartMessage("");

    try{
      // An earlier attempt for this build may have reached Shopify without a
      // confirmed response — check the cart rather than risk adding it twice.
      if(action.uncertain){
        const existing = await findBuilderLines(action.buildId);
        if(existing === null){
          showCartMessage(`<p>We still can't reach your cart to confirm whether your build was added. Check your cart before trying again.</p>${viewCartLink()}`);
          setCartButton("Try Again", false);
          return;
        }
        if(existing.length){ confirmCartAdd(action, selectedItems, existing); return; }
        action.uncertain = false;
      }

      // Underscore-prefixed properties are Shopify's convention for private line
      // item properties: hidden at checkout (and in carts that follow the
      // convention) but kept on the order for verifying builder-originated sales.
      const cartItems = selectedItems.map(it => ({
        id: parseInt(it.product.variantId, 10),
        quantity: 1,
        properties: Object.assign({}, it.properties || {}, { _boat_builder: "true", _boat_builder_id: action.buildId })
      }));

      let res = null, data = null;
      try{
        res = await fetchWithTimeout(cartUrl("cart/add.js"), {
          method: "POST",
          headers: {"Content-Type": "application/json", "Accept": "application/json"},
          body: JSON.stringify({ items: cartItems })
        });
        data = await res.json().catch(() => null);
      }catch(e){
        res = null; // network error or timeout — Shopify may still have added it
      }

      if(res && res.ok && data && Array.isArray(data.items)){
        const lines = data.items.filter(l => l.properties && l.properties._boat_builder_id === action.buildId);
        if(lines.length){ confirmCartAdd(action, selectedItems, lines); return; }
      }

      // Anything short of a confirmed success: ask the cart what actually happened.
      const existing = await findBuilderLines(action.buildId);
      if(existing && existing.length){ confirmCartAdd(action, selectedItems, existing); return; }

      if(existing && res && res.status >= 400 && res.status < 500){
        // Shopify rejected the add (e.g. stock limits) and the cart confirms nothing was added.
        const reason = data && (data.description || data.message);
        showCartMessage(`<p>${reason ? reason : "Shopify couldn't add these items."} Nothing from this build was added — adjust your selection and try again.</p>`);
        setCartButton("Add to Cart", false);
        return;
      }

      if(existing){
        // Cart readable and nothing from this build in it — safe to retry.
        showCartMessage(`<p>Something went wrong adding your build. Nothing was added — please try again.</p>`);
        setCartButton("Add to Cart", false);
        return;
      }

      // Couldn't confirm either way — the next attempt checks the cart first.
      action.uncertain = true;
      showCartMessage(`<p>We couldn't confirm whether your build was added. Check your cart before trying again — trying again here checks first and won't add it twice.</p>${viewCartLink()}`);
      setCartButton("Try Again", false);
    }finally{
      action.busy = false;
    }
  }

  function showCartResult(count, missing){
    const bar = document.getElementById("bd-app-cart-bar");
    if(bar) bar.style.display = "none";
    const note = missing ? `<p>${missing} selected item${missing===1?" was":"s were"} not added — check your cart.</p>` : "";
    showCartMessage(`<p>${count} item${count===1?"":"s"} added to your cart.</p>${note}${viewCartLink()}`);
  }

  /* =========================================================
     ROUTER
     ========================================================= */
  function render(){
    if(state.step === "boat") renderBoat();
    else if(state.step === "bow") renderBow("count");
    else if(state.step === "console") renderConsole("count");
    else if(state.step === "livescope") renderLiveScope("uses");
    else if(state.step === "results") renderResults();
  }

  updateManifest();
  updateZoneImage();
  setupManifestNav();
  render();
  observeBuilderView();

  // Kick off the live brand list in the background — doesn't block first
  // paint. If it resolves while the customer's still on the boat step, the
  // dropdown refreshes in place; otherwise it's already in effect for
  // whatever they select.
  fetchLiveBrands().then(brands=>{
    if(brands && brands.length){
      LIVE_BRANDS = brands;
      refreshBrandDropdownIfPresent();
    }
  });

})();